/* spellchecker: disable */

// TODO: fix this import, it break the aliases
// import { FeatureCollection } from 'geojson';
// import { FeatureCollection } from '@types/geojson';
import { FeatureCollection } from '../../node_modules/@types/geojson';

export const unescoData: FeatureCollection = {
  type: 'FeatureCollection',
  // name: 'world-heritage-site',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [47.235, 36.60388889],
      },
      properties: {
        title: 'Takht-e Soleyman',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-179.7152778, 71.18888889],
      },
      properties: {
        title: 'Natural System of Wrangel Island Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [139.6105556, 36.7475],
      },
      properties: {
        title: 'Shrines and Temples of Nikko',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [158.8955556, -54.59472222],
      },
      properties: {
        title: 'Macquarie Island',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.06028, 36.78333],
      },
      properties: {
        title: 'Kasbah of Algiers',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [166.1044444, -50.75],
      },
      properties: {
        title: 'New Zealand Sub-Antarctic Islands',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.16667, 36.81667],
      },
      properties: {
        title: 'Medina of Tunis',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-70.66666667, -47.15],
      },
      properties: {
        title: 'Cueva de las Manos, Río Pinturas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.32333, 36.85278],
      },
      properties: {
        title: 'Archaeological Site of Carthage',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-73.76666667, -42.5],
      },
      properties: {
        title: 'Churches of Chiloé',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.06891667, 36.89319444],
      },
      properties: {
        title: 'Late Baroque Towns of the Val di Noto (South-Eastern Sicily)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [145.4166667, -41.58333333],
      },
      properties: {
        title: 'Tasmanian Wilderness',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.09917, 36.94639],
      },
      properties: {
        title: 'Punic Town of Kerkuane and its Necropolis',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [175.5622222, -39.29083333],
      },
      properties: {
        title: 'Tongariro National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.358861, 36.9477],
      },
      properties: {
        title: 'Doñana National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-57.85333333, -34.46777778],
      },
      properties: {
        title: 'Historic Quarter of the City of Colonia del Sacramento',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.29306, 37.05944],
      },
      properties: {
        title: 'Syracuse and the Rocky Necropolis of Pantalica',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-70.3827777777, -34.0844444444],
      },
      properties: {
        title: 'Sewell Mining Town',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.36667, 37.08056],
      },
      properties: {
        title: 'Archaeological Site of Mystras',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [151.2152777777, -33.8566666667],
      },
      properties: {
        title: 'Sydney Opera House',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.67472, 37.16361],
      },
      properties: {
        title: 'Ichkeul National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [150.0, -33.7],
      },
      properties: {
        title: 'Greater Blue Mountains Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.59444, 37.17667],
      },
      properties: {
        title: 'Alhambra, Generalife and Albayzín, Granada',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-71.628, -33.04063889],
      },
      properties: {
        title: 'Historic Quarter of the Seaport City of Valparaíso',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-86.10305556, 37.18722222],
      },
      properties: {
        title: 'Mammoth Cave National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-64.19111, -31.42056],
      },
      properties: {
        title: 'Jesuit Block and Estancias of Córdoba',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [128.4527777778, 37.1972222222],
      },
      properties: {
        title: 'Royal Tombs of the Joseon Dynasty',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.54056, -29.38333],
      },
      properties: {
        title: 'uKhahlamba / Drakensberg Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [112.15444, 37.20139],
      },
      properties: {
        title: 'Ancient City of Ping Yao',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-54.26583333, -28.54333333],
      },
      properties: {
        title:
          'Jesuit Missions of the Guaranis: San Ignacio Mini, Santa Ana, Nuestra Señora de Loreto and Santa Maria Mayor (Argentina), Ruins of Sao Miguel das Missoes (Brazil)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [55.169, 37.2580277778],
      },
      properties: {
        title: 'Gonbad-e Qābus',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [32.55, -27.83889],
      },
      properties: {
        title: 'iSimangaliso Wetland Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-108.4855556, 37.26166667],
      },
      properties: {
        title: 'Mesa Verde National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-55.7, -27.13333],
      },
      properties: {
        title: 'Jesuit Missions of La Santísima Trinidad de Paraná and Jesús de Tavarangue',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [127.00833, 37.27222],
      },
      properties: {
        title: 'Hwaseong Fortress',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-54.43333, -25.68333],
      },
      properties: {
        title: 'Iguaçu National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.59333333, 37.28972222],
      },
      properties: {
        title: 'Archaeological Area of Agrigento',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [113.4361111, -25.48611111],
      },
      properties: {
        title: 'Shark Bay, Western Australia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.55, 37.3],
      },
      properties: {
        title: 'Historic Centre (Chorá) with the Monastery of Saint John',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [153.1333333, -25.21666667],
      },
      properties: {
        title: 'Fraser Island',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.33417, 37.36611],
      },
      properties: {
        title: 'Villa Romana del Casale',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-48.0, -24.16667],
      },
      properties: {
        title: 'Atlantic Forest South-East Reserves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.99155, 37.38384],
      },
      properties: {
        title: 'Cathedral, Alcázar and Archivo de Indias in Seville',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-65.34886111, -23.19986111],
      },
      properties: {
        title: 'Quebrada de Humahuaca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.26667, 37.4],
      },
      properties: {
        title: 'Delos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [113.8102777778, -22.5625],
      },
      properties: {
        title: 'Ningaloo Coast',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.89694, 37.43498],
      },
      properties: {
        title: 'Temple of Apollo Epicurius at Bassae',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [55.48, -21.0994444444],
      },
      properties: {
        title: 'Pitons, cirques and remparts of Reunion Island',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [126.98333, 37.55],
      },
      properties: {
        title: 'Jongmyo Shrine',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [28.5, -20.5],
      },
      properties: {
        title: 'Matobo Hills',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [126.9833333, 37.55],
      },
      properties: {
        title: 'Changdeokgung Palace Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [57.3283333333, -20.4519444444],
      },
      properties: {
        title: 'Le Morne Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.66666667, 37.65],
      },
      properties: {
        title: 'Archaeological Site of Olympia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-43.50555556, -20.38888889],
      },
      properties: {
        title: 'Historic Town of Ouro Preto',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [32.8280555556, 37.6666666667],
      },
      properties: {
        title: 'Neolithic Site of Çatalhöyük',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-69.79406, -20.20582],
      },
      properties: {
        title: 'Humberstone and Santa Laura Saltpeter Works',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.11666667, 37.66666667],
      },
      properties: {
        title: 'Sanctuary of Asklepios at Epidaurus',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [28.37666667, -20.15833333],
      },
      properties: {
        title: 'Khami Ruins National Monument',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.94333, 37.69083],
      },
      properties: {
        title: 'Pythagoreion and Heraion of Samos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [138.7166667, -19.08333333],
      },
      properties: {
        title: 'Australian Fossil Mammal Sites (Riversleigh / Naracoorte)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [62.1775, 37.70083],
      },
      properties: {
        title: 'State Historical and Cultural Park “Ancient Merv”',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [47.56278, -18.75917],
      },
      properties: {
        title: 'Royal Hill of Ambohimanga',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.75, 37.73333333],
      },
      properties: {
        title: 'Archaeological Sites of Mycenae and Tiryns',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [44.75, -18.66667],
      },
      properties: {
        title: 'Tsingy de Bemaraha Strict Nature Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-119.5966667, 37.74611111],
      },
      properties: {
        title: 'Yosemite National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-43.6, -18.23333333],
      },
      properties: {
        title: 'Historic Centre of the Town of Diamantina',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.779722222, 37.87919444],
      },
      properties: {
        title: 'Historic Centre of Cordoba',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.85539, -17.92453],
      },
      properties: {
        title: 'Mosi-oa-Tunya / Victoria Falls',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.12333, 37.92389],
      },
      properties: {
        title: 'Hierapolis-Pamukkale',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [168.1777194444, -17.6280694444],
      },
      properties: {
        title: 'Chief Roi Mata’s Domain',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.72618, 37.97087],
      },
      properties: {
        title: 'Acropolis, Athens',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-68.67778, -16.55833333],
      },
      properties: {
        title: 'Tiwanaku: Spiritual and Political Centre of the Tiwanaku Culture',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [58.1986111111, 37.9997222222],
      },
      properties: {
        title: 'Parthian Fortresses of Nisa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-71.53333333, -16.4],
      },
      properties: {
        title: 'Historical Centre of the City of Arequipa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.37122, 38.01131],
      },
      properties: {
        title: 'Renaissance Monumental Ensembles of Úbeda and Baeza',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-50.13336, -15.93328],
      },
      properties: {
        title: 'Historic Centre of the Town of Goiás',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-78.50388889, 38.03277778],
      },
      properties: {
        title: 'Monticello and the University of Virginia in Charlottesville',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-47.9, -15.78333],
      },
      properties: {
        title: 'Brasilia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.76369, 38.03661],
      },
      properties: {
        title: 'Nemrut Dağ',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [40.73583, -15.03417],
      },
      properties: {
        title: 'Island of Mozambique',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [46.2930555556, 38.0813888889],
      },
      properties: {
        title: 'Tabriz Historic Bazaar Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [49.7025, -14.4597222222],
      },
      properties: {
        title: 'Rainforests of the Atsinanana',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [48.2913888889, 38.2486111111],
      },
      properties: {
        title: 'Sheikh Safi al-din Khānegāh and Shrine Ensemble in Ardabil',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-60.86667, -14.26667],
      },
      properties: {
        title: 'Noel Kempff Mercado National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.716666667, 38.26666667],
      },
      properties: {
        title: 'Palmeral of Elche',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-47.68461111, -14.00569444],
      },
      properties: {
        title: 'Cerrado Protected Areas: Chapada dos Veadeiros and Emas National Parks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.75, 38.4],
      },
      properties: {
        title: 'Monasteries of Daphni, Hosios Loukas and Nea Moni of Chios',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-72.58333333, -13.11666667],
      },
      properties: {
        title: 'Historic Sanctuary of Machu Picchu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.49617, 38.48149],
      },
      properties: {
        title: 'Archaeological Site of Delphi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [132.8333333, -12.83333333],
      },
      properties: {
        title: 'Kakadu National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.94558333, 38.48786111],
      },
      properties: {
        title: 'Isole Eolie (Aeolian Islands)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.04306, -12.05139],
      },
      properties: {
        title: 'Historic Centre of Lima',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-28.54116667, 38.51344444],
      },
      properties: {
        title: 'Landscape of the Pico Island Vineyard Culture',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-37.21, -11.0161111111],
      },
      properties: {
        title: 'São Francisco Square in the Town of São Cristóvão',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.90778, 38.57306],
      },
      properties: {
        title: 'Historic Centre of Évora',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.1784535027, -9.5927725444],
      },
      properties: {
        title: 'Chavin (Archaeological Site)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-27.22, 38.655],
      },
      properties: {
        title: 'Central Zone of the Town of Angra do Heroismo in the Azores',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.4, -9.33333],
      },
      properties: {
        title: 'Huascarán National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-90.06138889, 38.65861111],
      },
      properties: {
        title: 'Cahokia Mounds State Historic Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [39.52278, -8.95778],
      },
      properties: {
        title: 'Ruins of Kilwa Kisiwani and Ruins of Songo Mnara',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.85, 38.66667],
      },
      properties: {
        title: 'Göreme National Park and the Rock Sites of Cappadocia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-42.33333333, -8.416666667],
      },
      properties: {
        title: 'Serra da Capivara National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.21583, 38.69194],
      },
      properties: {
        title: 'Monastery of the Hieronymites and Tower of Belém in Lisbon',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-79.08333, -8.1],
      },
      properties: {
        title: 'Chan Chan Archaeological Zone',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.8388888889, 38.7752777778],
      },
      properties: {
        title: 'Heritage of Mercury. Almadén and Idrija',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [110.49167, -7.75222],
      },
      properties: {
        title: 'Prambanan Temple Compounds',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.41667, 38.78333],
      },
      properties: {
        title: 'Cultural Landscape of Sintra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [110.20361, -7.60778],
      },
      properties: {
        title: 'Borobudur Temple Compounds',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [125.415, 38.86305556],
      },
      properties: {
        title: 'Complex of Koguryo Tombs',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [105.3333333, -6.75],
      },
      properties: {
        title: 'Ujung Kulon National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.1633222222, 38.8806194444],
      },
      properties: {
        title: 'Garrison Border Town of Elvas and its Fortifications',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [144.3317222222, -5.7837111111],
      },
      properties: {
        title: 'Kuk Early Agricultural Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.435194444, 38.91113889],
      },
      properties: {
        title: 'Ibiza, Biodiversity and Culture',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.8338888888, -4.7244444444],
      },
      properties: {
        title: 'Kondoa Rock-Art Sites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.33778, 38.91611],
      },
      properties: {
        title: 'Archaeological Ensemble of Mérida',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [39.6794444444, -4.0627777778],
      },
      properties: {
        title: 'Fort Jesus, Mombasa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [140.9591666667, 38.9730555556],
      },
      properties: {
        title: 'Hiraizumi – Temples, Gardens and Archaeological Sites Representing the Buddhist Pure Land',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-32.42511111, -3.857944444],
      },
      properties: {
        title: 'Brazilian Atlantic Islands: Fernando de Noronha and Atol das Rocas Reserves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [45.4733333333, 38.9788888889],
      },
      properties: {
        title: 'Armenian Monastic Ensembles of Iran',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.54083, -3.18722],
      },
      properties: {
        title: 'Ngorongoro Conservation Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [141.1077777778, 39.0011111111],
      },
      properties: {
        title: 'Hiraizumi – Temples, Gardens and Archaeological Sites Representing the Buddhist Pure Land',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-78.98333333, -2.883333333],
      },
      properties: {
        title: 'Historic Centre of Santa Ana de los Ríos de Cuenca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [113.5633333333, 39.0305555556],
      },
      properties: {
        title: 'Mount Wutai',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [28.75, -2.5],
      },
      properties: {
        title: 'Kahuzi-Biega National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [66.83333, 39.05],
      },
      properties: {
        title: 'Historic Centre of Shakhrisyabz',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-62.00833333, -2.333333333],
      },
      properties: {
        title: 'Central Amazon Conservation Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.12361, 39.37361],
      },
      properties: {
        title: 'Great Mosque and Hospital of Divriği',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [40.8525, -2.284444444],
      },
      properties: {
        title: 'Lamu Old Town',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.3275, 39.45285],
      },
      properties: {
        title: 'Royal Monastery of Santa María de Guadalupe',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-78.33333, -1.83333],
      },
      properties: {
        title: 'Sangay National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.378444444, 39.47441667],
      },
      properties: {
        title: 'La Lonja de la Seda de Valencia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-91.0, -0.81667],
      },
      properties: {
        title: 'Galápagos Islands',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.37, 39.47444],
      },
      properties: {
        title: 'Old Town of Cáceres',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.24, -0.4425],
      },
      properties: {
        title: 'Kenya Lake System in the Great Rift Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [67.4602777778, 39.5077777778],
      },
      properties: {
        title: 'Proto-urban Site of Sarazm',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-78.5, -0.003888889],
      },
      properties: {
        title: 'City of Quito',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.97667, 39.55],
      },
      properties: {
        title: 'Monastery of Alcobaça',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [32.55138889, 0.348611111],
      },
      properties: {
        title: 'Tombs of Buganda Kings at Kasubi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.4175, 39.60472],
      },
      properties: {
        title: 'Convent of Christ in Tomar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-76.23333333, 1.916666667],
      },
      properties: {
        title: 'San Agustín Archaeological Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.9275, 39.6239413889],
      },
      properties: {
        title: 'Old Town of Corfu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.8141666667, 2.3672222222],
      },
      properties: {
        title: 'Sangha Trinational',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.82694, 39.65778],
      },
      properties: {
        title: 'Monastery of Batalha',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.5541666667, 2.6094444444],
      },
      properties: {
        title: 'Sangha Trinational',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [67.0, 39.66861],
      },
      properties: {
        title: 'Samarkand – Crossroad of Cultures',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.0, 3.0],
      },
      properties: {
        title: 'Dja Faunal Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.991388889, 39.70583333],
      },
      properties: {
        title: 'Su Nuraxi di Barumini',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-81.6166666666, 3.9666666667],
      },
      properties: {
        title: 'Malpelo Fauna and Flora Sanctuary',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.63333, 39.71667],
      },
      properties: {
        title: 'Meteora',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.25, 4.0],
      },
      properties: {
        title: 'Garamba National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.6947222222, 39.7308333333],
      },
      properties: {
        title: 'Cultural Landscape of the Serra de Tramuntana',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.96666667, 4.8],
      },
      properties: {
        title: 'Lower Valley of the Omo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [115.9166667, 39.73333333],
      },
      properties: {
        title: 'Peking Man Site at Zhoukoudian',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.7363888889, 5.1958333333],
      },
      properties: {
        title: 'Historic Town of Grand-Bassam',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.02611111, 39.75111111],
      },
      properties: {
        title: 'Butrint',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-61.5, 5.33333],
      },
      properties: {
        title: 'Canaima National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [64.42861, 39.77472],
      },
      properties: {
        title: 'Historic Centre of Bukhara',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [100.3458333333, 5.4213888889],
      },
      properties: {
        title: 'Melaka and George Town, Historic Cities of the Straits of Malacca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.03331, 39.78995],
      },
      properties: {
        title: 'Rock Art of the Mediterranean Basin on the Iberian Peninsula',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-87.06666667, 5.533333333],
      },
      properties: {
        title: 'Cocos Island National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [116.4447222, 39.84555556],
      },
      properties: {
        title: 'Temple of Heaven: an Imperial Sacrificial Altar in Beijing',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-55.15, 5.82611],
      },
      properties: {
        title: 'Historic Inner City of Paramaribo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.029416667, 39.86688889],
      },
      properties: {
        title: 'Historic City of Toledo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [116.5, 6.25],
      },
      properties: {
        title: 'Kinabalu Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [116.1411111, 39.91055556],
      },
      properties: {
        title: 'Summer Palace, an Imperial Garden in Beijing',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.5, 6.416666667],
      },
      properties: {
        title: 'Sinharaja Forest Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.15, 39.94861111],
      },
      properties: {
        title: 'Independence Hall',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [134.3525, 7.246925],
      },
      properties: {
        title: 'Rock Islands Southern Lagoon',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.239, 39.95644],
      },
      properties: {
        title: 'Archaeological Site of Troy',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-81.766, 7.433],
      },
      properties: {
        title: 'Coiba National Park and its Special Zone of Marine Protection',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.62056, 40.01389],
      },
      properties: {
        title: 'Hattusha: the Hittite Capital',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.39097, 7.60318],
      },
      properties: {
        title: 'Mount Nimba Strict Nature Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.60934, 40.03645],
      },
      properties: {
        title: 'Aranjuez Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.54722222, 7.736111111],
      },
      properties: {
        title: 'Darien National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.13333333, 40.06944444],
      },
      properties: {
        title: 'Historic Centres of Berat and Gjirokastra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.64916667, 7.856666667],
      },
      properties: {
        title: 'Golden Temple of Dambulla',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.1408333333, 40.0741666667],
      },
      properties: {
        title: 'Historic Centres of Berat and Gjirokastra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.75, 7.95],
      },
      properties: {
        title: 'Ancient City of Sigiriya',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.13174, 40.07662],
      },
      properties: {
        title: 'Historic Walled Town of Cuenca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.6121, 8.43491],
      },
      properties: {
        title: 'Tiya',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [113.12222, 40.10972],
      },
      properties: {
        title: 'Yungang Grottoes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-79.54055556, 8.951111111],
      },
      properties: {
        title: 'Archaeological Site of Panamá Viejo and Historic District of Panamá',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [49.375, 40.125],
      },
      properties: {
        title: 'Gobustan Rock Art Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.0, 9.0],
      },
      properties: {
        title: 'Comoé National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [94.81667, 40.13333],
      },
      properties: {
        title: 'Mogao Caves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-74.43333333, 9.233333333],
      },
      properties: {
        title: 'Historic Centre of Santa Cruz de Mompox',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [44.79667, 40.15889],
      },
      properties: {
        title: 'Monastery of Geghard and the Upper Azat Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-82.93880556, 9.407083333],
      },
      properties: {
        title: 'Talamanca Range-La Amistad Reserves / La Amistad National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [44.29514, 40.15931],
      },
      properties: {
        title: 'Cathedral and Churches of Echmiatsin and the Archaeological Site of Zvartnots',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.133333333, 10.06666667],
      },
      properties: {
        title: 'Koutammakou, the Land of the Batammariba',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.21667, 40.26667],
      },
      properties: {
        title: 'Mount Athos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.5833333333, 10.25],
      },
      properties: {
        title: 'Ruins of Loropéni',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.26666667, 40.28333333],
      },
      properties: {
        title:
          'Cilento and Vallo di Diano National Park with the Archeological Sites of Paestum and Velia, and the Certosa di Padula',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-66.89068, 10.49073],
      },
      properties: {
        title: 'Ciudad Universitaria de Caracas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.10722, 40.34389],
      },
      properties: {
        title: 'Mudejar Architecture of Aragon',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [79.1325, 10.78305556],
      },
      properties: {
        title: 'Great Living Chola Temples',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [49.83333333, 40.36666667],
      },
      properties: {
        title: "Walled City of Baku with the Shirvanshah's Palace and Maiden Tower",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [40.57939, 11.10006],
      },
      properties: {
        title: 'Lower Valley of the Awash',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [116.08333, 40.41667],
      },
      properties: {
        title: 'The Great Wall',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [76.93583, 11.51028],
      },
      properties: {
        title: 'Mountain Railways of India',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [140.13, 40.47],
      },
      properties: {
        title: 'Shirakami-Sanchi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [39.04042, 12.02935],
      },
      properties: {
        title: 'Rock-Hewn Churches, Lalibela',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.31833, 40.47139],
      },
      properties: {
        title: 'Archaeological Site of Aigai (modern name Vergina)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.35, 12.35],
      },
      properties: {
        title: 'W National Park of Niger',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.368055556, 40.48138889],
      },
      properties: {
        title: 'University and Historic Precinct of Alcalá de Henares',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-86.8780555556, 12.435],
      },
      properties: {
        title: 'León Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [72.7827777778, 40.5311111111],
      },
      properties: {
        title: 'Sulaiman-Too Sacred Mountain',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-12.8458333333, 12.5933333333],
      },
      properties: {
        title: 'Bassari Country: Bassari, Fula and Bedik Cultural Landscapes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.126416667, 40.58175],
      },
      properties: {
        title: 'Monastery and Site of the Escurial, Madrid',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.19167, 12.61667],
      },
      properties: {
        title: 'Group of Monuments at Mahabalipuram',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.965, 40.63833],
      },
      properties: {
        title: 'Paleochristian and Byzantine Monuments of Thessalonika',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-59.6138888889, 13.0966666667],
      },
      properties: {
        title: 'Historic Bridgetown and its Garrison',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.6, 40.65],
      },
      properties: {
        title: 'Costiera Amalfitana',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.35719444, 13.31616667],
      },
      properties: {
        title: 'Kunta Kinteh Island and Related Sites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.70012, 40.65645],
      },
      properties: {
        title: 'Old Town of Ávila with its Extra-Muros Churches',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-15.5225, 13.6911111111],
      },
      properties: {
        title: 'Stone Circles of Senegambia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.61027778, 40.66638889],
      },
      properties: {
        title: 'The Sassi and the Park of the Rupestrian Churches of Matera',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-61.07036111, 13.80708333],
      },
      properties: {
        title: 'Pitons Management Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-74.04472222, 40.68944444],
      },
      properties: {
        title: 'Statue of Liberty',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.4986111111, 13.8352777778],
      },
      properties: {
        title: 'Saloum Delta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.6611111111, 40.6975],
      },
      properties: {
        title: 'Prehistoric Rock Art Sites in the Côa Valley and Siega Verde',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.71861, 14.13019],
      },
      properties: {
        title: 'Aksum',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.48333333, 40.75],
      },
      properties: {
        title: 'Archaeological Areas of Pompei, Herculaneum and Torre Annunziata',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [102.05, 14.33],
      },
      properties: {
        title: 'Dong Phayayen-Khao Yai Forest Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.23694, 40.7825],
      },
      properties: {
        title: 'The Trulli of Alberobello',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [100.56056, 14.34778],
      },
      properties: {
        title: 'Historic City of Ayutthaya',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.26277778, 40.85138889],
      },
      properties: {
        title: 'Historic Centre of Naples',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-90.66666667, 14.56666667],
      },
      properties: {
        title: 'Antigua Guatemala',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.11675, 40.94847222],
      },
      properties: {
        title: 'Old Town of Segovia and its Aqueduct',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-17.40083, 14.66722],
      },
      properties: {
        title: 'Island of Gorée',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.6645, 40.96525],
      },
      properties: {
        title: 'Old City of Salamanca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-89.13333, 14.85],
      },
      properties: {
        title: 'Maya Site of Copan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [117.93833, 40.98694],
      },
      properties: {
        title: 'Mountain Resort and its Outlying Temples, Chengde',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-61.28333333, 15.26666667],
      },
      properties: {
        title: 'Morne Trois Pitons National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [28.97993, 41.00847],
      },
      properties: {
        title: 'Historic Areas of Istanbul',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [76.47167, 15.31444],
      },
      properties: {
        title: 'Group of Monuments at Hampi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.32639, 41.07333],
      },
      properties: {
        title:
          '18th-Century Royal Palace at Caserta with the Park, the Aqueduct of Vanvitelli, and the San Leucio Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [44.20805556, 15.35555556],
      },
      properties: {
        title: "Old City of Sana'a",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.27094444, 41.08480556],
      },
      properties: {
        title: 'Castel del Monte',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [108.5666667, 15.51666667],
      },
      properties: {
        title: 'My Son Sanctuary',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [44.71028, 41.095],
      },
      properties: {
        title: 'Monasteries of Haghpat and Sanahin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [108.3333333, 15.88333333],
      },
      properties: {
        title: 'Hoi An Ancient Town',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.798888889, 41.10166667],
      },
      properties: {
        title: 'Alto Douro Wine Region',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [75.81667, 15.94833],
      },
      properties: {
        title: 'Group of Monuments at Pattadakal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.259305556, 41.11472222],
      },
      properties: {
        title: 'Archaeological Ensemble of Tárraco',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.04456, 16.2898],
      },
      properties: {
        title: 'Tomb of Askia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.81333, 41.11806],
      },
      properties: {
        title: 'Natural and Cultural Heritage of the Ohrid region',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.16667, 16.5],
      },
      properties: {
        title: 'Djoudj National Bird Sanctuary',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.616666667, 41.14166667],
      },
      properties: {
        title: 'Historic Centre of Oporto',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.999444444, 16.77333333],
      },
      properties: {
        title: 'Timbuktu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [126.1872222, 41.15694444],
      },
      properties: {
        title: 'Capital Cities and Tombs of the Ancient Koguryo Kingdom',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [121.13667, 16.93389],
      },
      properties: {
        title: 'Rice Terraces of the Philippine Cordilleras',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [32.68972, 41.26],
      },
      properties: {
        title: 'City of Safranbolu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [99.78972, 17.00722],
      },
      properties: {
        title: 'Historic Town of Sukhothai and Associated Historic Towns',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-123.9980556, 41.37388889],
      },
      properties: {
        title: 'Redwood National and State Parks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-89.61666667, 17.21666667],
      },
      properties: {
        title: 'Tikal National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [60.36389, 41.37833],
      },
      properties: {
        title: 'Itchan Kala',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-92.05, 17.48333],
      },
      properties: {
        title: 'Pre-Hispanic City and National Park of Palenque',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.0825, 41.38083],
      },
      properties: {
        title: 'Poblet Monastery',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.35833, 17.54861],
      },
      properties: {
        title: 'Ban Chiang Archaeological Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.175, 41.38778],
      },
      properties: {
        title: 'Palau de la Música Catalana and Hospital de Sant Pau, Barcelona',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.0, 18.0],
      },
      properties: {
        title: 'Air and Ténéré Natural Reserves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.152972, 41.41338],
      },
      properties: {
        title: 'Works of Antoni Gaudí',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [53.64759, 18.25333],
      },
      properties: {
        title: 'Land of Frankincense',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.29482, 41.44083],
      },
      properties: {
        title: 'Historic Centre of Guimarães',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-69.91666667, 18.48333333],
      },
      properties: {
        title: 'Colonial City of Santo Domingo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.5594444444, 41.6777777778],
      },
      properties: {
        title: 'Selimiye Mosque and its Social Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-95.65833333, 18.60833333],
      },
      properties: {
        title: 'Historic Monuments Zone of Tlacotalpan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [124.7938889, 41.70722222],
      },
      properties: {
        title: 'Imperial Tombs of the Ming and Qing Dynasties',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-98.89778, 18.93472],
      },
      properties: {
        title: 'Earliest 16th-Century Monasteries on the Slopes of Popocatepetl',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.4304722222, 41.7427222222],
      },
      properties: {
        title: 'Pirin National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [72.93583, 18.96667],
      },
      properties: {
        title: 'Elephanta Caves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [123.4469444, 41.79416667],
      },
      properties: {
        title: 'Imperial Palaces of the Ming and Qing Dynasties in Beijing and Shenyang',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.5055555556, 19.055],
      },
      properties: {
        title: 'Lakes of Ounianga',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [44.71639, 41.84389],
      },
      properties: {
        title: 'Historical Monuments of Mtskheta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-87.79167, 19.38333],
      },
      properties: {
        title: "Sian Ka'an",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.49230556, 41.89022222],
      },
      properties: {
        title:
          'Historic Centre of Rome, the Properties of the Holy See in that City Enjoying Extraterritorial Rights and San Paolo Fuori le Mura',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-99.13278, 19.41833],
      },
      properties: {
        title: 'Historic Centre of Mexico City and Xochimilco',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.45736, 41.90216],
      },
      properties: {
        title: 'Vatican City',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-72.24417, 19.57361],
      },
      properties: {
        title: 'National History Park – Citadel, Sans Souci, Ramiers',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.77197222, 41.94416667],
      },
      properties: {
        title: 'Villa Adriana (Tivoli)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-98.84167, 19.69167],
      },
      properties: {
        title: 'Pre-Hispanic City of Teotihuacan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.79625, 41.96391667],
      },
      properties: {
        title: "Villa d'Este, Tivoli",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-101.19167, 19.70444],
      },
      properties: {
        title: 'Historic Centre of Morelia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.10188889, 42.00683333],
      },
      properties: {
        title: 'Etruscan Necropolises of Cerveteri and Tarquinia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.63333, 19.88333],
      },
      properties: {
        title: 'Desembarco del Granma National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [48.29719444, 42.05297222],
      },
      properties: {
        title: 'Citadel, Ancient City and Fortress Buildings of Derbent',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [102.13333, 19.88889],
      },
      properties: {
        title: 'Town of Luang Prabang',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.4, 42.11666667],
      },
      properties: {
        title: 'Rila Monastery',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-100.1308333333, 19.9813888889],
      },
      properties: {
        title: 'Monarch Butterfly Biosphere Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [59.08494, 42.18318],
      },
      properties: {
        title: 'Kunya-Urgench',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.39138889, 20.03],
      },
      properties: {
        title: 'Archaeological Landscape of the First Coffee Plantations in the South-East of Cuba',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [42.71639, 42.26222],
      },
      properties: {
        title: 'Bagrati Cathedral and Gelati Monastery',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.10889, 20.23472],
      },
      properties: {
        title: "Banc d'Arguin National Park",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.628833333, 42.32519444],
      },
      properties: {
        title: 'Gulf of Porto: Calanche of Piana, Gulf of Girolata, Scandola Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.0, 20.45],
      },
      properties: {
        title: 'Alejandro de Humboldt National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.86496, 42.32586],
      },
      properties: {
        title: 'San Millán Yuso and Suso Monasteries',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [75.7, 20.55333],
      },
      properties: {
        title: 'Ajanta Caves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.70401, 42.3402],
      },
      properties: {
        title: 'Burgos Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-88.6, 20.66667],
      },
      properties: {
        title: 'Pre-Hispanic City of Chichen-Itza',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [116.1851277778, 42.358],
      },
      properties: {
        title: 'Site of Xanadu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-103.7786111111, 20.8630555555],
      },
      properties: {
        title: 'Agave Landscape and Ancient Industrial Facilities of Tequila',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.547222222, 42.37138889],
      },
      properties: {
        title: 'Archaeological Site of Atapuerca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-100.7463888889, 20.9144444444],
      },
      properties: {
        title: 'Protective town of San Miguel and the Sanctuary of Jesús Nazareno de Atotonilco',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.88333, 42.45917],
      },
      properties: {
        title: 'Route of Santiago de Compostela',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-101.25556, 21.01694],
      },
      properties: {
        title: 'Historic Town of Guanajuato and Adjacent Mines',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.77075, 42.46939],
      },
      properties: {
        title: 'Las Médulas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-99.46411111, 21.20438889],
      },
      properties: {
        title: 'Franciscan Missions in the Sierra Gorda of Querétaro',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.7, 42.48333],
      },
      properties: {
        title: 'Natural and Culturo-Historical Region of Kotor',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-79.98444444, 21.80305556],
      },
      properties: {
        title: 'Trinidad and the Valley de los Ingenios',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.595555556, 42.49472222],
      },
      properties: {
        title: 'Madriu-Perafita-Claror Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [89.18333, 21.95],
      },
      properties: {
        title: 'The Sundarbans',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0.803611111, 42.50472222],
      },
      properties: {
        title: 'Catalan Romanesque Churches of the Vall de Boí',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [113.5364611111, 22.1912919444],
      },
      properties: {
        title: 'Historic Centre of Macao',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.4, 42.61666667],
      },
      properties: {
        title: 'Thracian Tomb of Kazanlak',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [31.62611, 22.33639],
      },
      properties: {
        title: 'Nubian Monuments from Abu Simbel to Philae',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.26666667, 42.65],
      },
      properties: {
        title: 'Boyana Church',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-102.3791666667, 22.6080555556],
      },
      properties: {
        title: 'Camino Real de Tierra Adentro',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.09139, 42.65056],
      },
      properties: {
        title: 'Old City of Dubrovnik',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [89.8, 22.66667],
      },
      properties: {
        title: 'Historic Mosque City of Bagerhat',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [27.73, 42.65611],
      },
      properties: {
        title: 'Ancient City of Nessebar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.58333333, 22.92777778],
      },
      properties: {
        title: 'Rock Shelters of Bhimbetka',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.2655555555, 42.6611111111],
      },
      properties: {
        title: 'Medieval Monuments in Kosovo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [57.5360555555, 22.9988888889],
      },
      properties: {
        title: 'Aflaj Irrigation Systems of Oman',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.0005, 42.68542],
      },
      properties: {
        title: 'Pyrénées - Mont Perdu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [56.745, 23.26986],
      },
      properties: {
        title: 'Archaeological Sites of Bat, Al-Khutm and Al-Ayn',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.54468, 42.88076],
      },
      properties: {
        title: 'Santiago de Compostela (Old Town)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [55.8063888889, 24.0677777778],
      },
      properties: {
        title: 'Cultural Sites of Al Ain (Hafit, Hili, Bidaa Bint Saud and Oases Areas)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [43.01139, 42.91639],
      },
      properties: {
        title: 'Upper Svaneti',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [84.99389, 24.69528],
      },
      properties: {
        title: 'Mahabodhi Temple Complex at Bodh Gaya',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.55333, 43.01111],
      },
      properties: {
        title: 'Roman Walls of Lugo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [67.9, 24.76666667],
      },
      properties: {
        title: 'Historical Monuments at Makli, Thatta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.62244444, 43.06616667],
      },
      properties: {
        title: 'Assisi, the Basilica of San Francesco and Other Franciscan Sites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [79.92222, 24.85222],
      },
      properties: {
        title: 'Khajuraho Group of Monuments',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.55, 43.06666667],
      },
      properties: {
        title: "Val d'Orcia",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [88.98333333, 25.03333333],
      },
      properties: {
        title: 'Ruins of the Buddhist Vihara at Paharpur',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.67861111, 43.07694444],
      },
      properties: {
        title: 'Historic Centre of the City of Pienza',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-170.14582, 25.34907],
      },
      properties: {
        title: 'Papahānaumokuākea',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.42278, 43.11889],
      },
      properties: {
        title: 'Stari Ras and Sopoćani',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-80.99638889, 25.55444444],
      },
      properties: {
        title: 'Everglades National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.0166, 43.133],
      },
      properties: {
        title: 'Durmitor National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [127.6827778, 26.20861111],
      },
      properties: {
        title: 'Gusuku Sites and Related Properties of the Kingdom of Ryukyu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.6386111111, 43.1816666667],
      },
      properties: {
        title: 'Stari Grad Plain',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [50.61351, 26.24128],
      },
      properties: {
        title: 'Pearling, Testimony of an Island Economy',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.358888889, 43.21055556],
      },
      properties: {
        title: 'Historic Fortified City of Carcassonne',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [91.03055556, 26.725],
      },
      properties: {
        title: 'Manas Wildlife Sanctuary',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [68.27444444, 43.29305556],
      },
      properties: {
        title: 'Mausoleum of Khoja Ahmed Yasawi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [100.23333, 26.86667],
      },
      properties: {
        title: 'Old Town of Lijiang',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [27.15, 43.3],
      },
      properties: {
        title: 'Madara Rider',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.66417, 27.09444],
      },
      properties: {
        title: 'Fatehpur Sikri',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.33166667, 43.31861111],
      },
      properties: {
        title: 'Historic Centre of Siena',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [78.04222, 27.17417],
      },
      properties: {
        title: 'Taj Mahal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.0168333333, 43.323175],
      },
      properties: {
        title: 'Vizcaya Bridge',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [68.13888889, 27.32916667],
      },
      properties: {
        title: 'Archaeological Ruins at Moenjodaro',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.81092, 43.34812],
      },
      properties: {
        title: 'Old Bridge Area of the Old City of Mostar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [84.33333, 27.5],
      },
      properties: {
        title: 'Chitwan National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.84303, 43.36262],
      },
      properties: {
        title: 'Monuments of Oviedo and the Kingdom of the Asturias',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-112.91611, 27.65556],
      },
      properties: {
        title: 'Rock Paintings of the Sierra de San Francisco',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.116166667, 43.38252778],
      },
      properties: {
        title: 'Cave of Altamira and Paleolithic Cave Art of Northern Spain',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [117.68333, 27.71667],
      },
      properties: {
        title: 'Mount Wuyi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.4063888889, 43.3858333333],
      },
      properties: {
        title: 'Tower of Hercules',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-114.22778, 27.79222],
      },
      properties: {
        title: 'Whale Sanctuary of El Vizcaino',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.04167, 43.46806],
      },
      properties: {
        title: 'Historic Centre of San Gimignano',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [86.91306, 27.96528],
      },
      properties: {
        title: 'Sagarmatha National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.53667, 43.48611],
      },
      properties: {
        title: 'Studenica Monastery',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.6436111111, 28.2713888889],
      },
      properties: {
        title: 'Teide National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.44333, 43.50944],
      },
      properties: {
        title: 'Historical Complex of Split with the Palace of Diocletian',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.31177778, 28.47788889],
      },
      properties: {
        title: 'San Cristóbal de La Laguna',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.25167, 43.5125],
      },
      properties: {
        title: 'Historic City of Trogir',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [33.97543, 28.55623],
      },
      properties: {
        title: 'Saint Catherine Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.416388889, 43.61138889],
      },
      properties: {
        title: 'Canal du Midi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.2408333333, 28.6555555556],
      },
      properties: {
        title: 'Red Fort Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.66667, 43.66667],
      },
      properties: {
        title: 'Thracian Tomb of Sveshtari',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [58.3666666667, 29.11683],
      },
      properties: {
        title: 'Bam and its Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.630694444, 43.67763889],
      },
      properties: {
        title: 'Arles, Roman and Romanesque Monuments',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [110.5, 29.33333],
      },
      properties: {
        title: 'Wulingyuan Scenic and Historic Interest Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.96666667, 43.71666667],
      },
      properties: {
        title: 'Rock-Hewn Churches of Ivanovo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.76925, 29.5449],
      },
      properties: {
        title: 'Mount Emei Scenic Area, including Leshan Giant Buddha Scenic Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.39638889, 43.72305556],
      },
      properties: {
        title: 'Piazza del Duomo, Pisa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [91.11717, 29.65792],
      },
      properties: {
        title: 'Historic Ensemble of the Potala Palace, Lhasa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.63333, 43.725],
      },
      properties: {
        title: 'Historic Centre of Urbino',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [117.9875, 29.90444444],
      },
      properties: {
        title: 'Ancient Villages in Southern Anhui – Xidi and Hongcun',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.89038, 43.73629],
      },
      properties: {
        title: 'The Cathedral of St James in Šibenik',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [31.13041, 29.97604],
      },
      properties: {
        title: 'Memphis and its Necropolis – the Pyramid Fields from Giza to Dahshur',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.25611, 43.77306],
      },
      properties: {
        title: 'Historic Centre of Florence',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.5, 30.13333333],
      },
      properties: {
        title: 'Old Town of Ghadamès',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.288025, 43.7814444444],
      },
      properties: {
        title: 'Mehmed Paša Sokolović Bridge in Višegrad',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [118.18333, 30.16667],
      },
      properties: {
        title: 'Mount Huangshan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [75.535, 43.80333333],
      },
      properties: {
        title: 'Petroglyphs within the Archaeological Landscape of Tamgaly',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [120.1408333333, 30.2375],
      },
      properties: {
        title: 'West Lake Cultural Landscape of Hangzhou',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.1861111111, 43.8993055556],
      },
      properties: {
        title: 'Gamzigrad-Romuliana, Palace of Galerius',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [130.5333333, 30.33333333],
      },
      properties: {
        title: 'Yakushima',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.1425, 43.9283333333],
      },
      properties: {
        title: 'Episcopal City of Albi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.16083, 30.54111],
      },
      properties: {
        title: 'Incense Route - Desert Cities in the Negev',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.4519444444, 43.9327777778],
      },
      properties: {
        title: 'San Marino Historic Centre and Mount Titano',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.0, 30.8333333333],
      },
      properties: {
        title: 'Sichuan Giant Panda Sanctuaries - Wolong, Mt Siguniang and Jiajin Mountains',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.535277778, 43.94722222],
      },
      properties: {
        title: 'Pont du Gard (Roman Aqueduct)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.60528, 31.00167],
      },
      properties: {
        title: 'Mount Qingcheng and the Dujiangyan Irrigation System',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [144.96583, 43.94944],
      },
      properties: {
        title: 'Shiretoko',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.35275, 31.3135],
      },
      properties: {
        title: 'Masada',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.806111111, 43.95277778],
      },
      properties: {
        title: 'Historic Centre of Avignon: Papal Palace, Episcopal Ensemble and Avignon Bridge',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.92056, 31.50167],
      },
      properties: {
        title: "Um er-Rasas (Kastrom Mefa'a)",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [40.0, 44.0],
      },
      properties: {
        title: 'Western Caucasus',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [74.30972222, 31.59027778],
      },
      properties: {
        title: 'Fort and Shalamar Gardens in Lahore',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.72917, 44.10694],
      },
      properties: {
        title: 'Portovenere, Cinque Terre, and the Islands (Palmaria, Tino and Tinetto)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.2075, 31.7043527778],
      },
      properties: {
        title: 'Birthplace of Jesus: Church of the Nativity and the Pilgrimage Route, Bethlehem',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [27.07806, 44.11444],
      },
      properties: {
        title: 'Srebarna Nature Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.58583, 31.80194],
      },
      properties: {
        title: 'Quseir Amra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.808416667, 44.13572222],
      },
      properties: {
        title: 'Roman Theatre and its Surroundings and the "Triumphal Arch" of Orange',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.78333333, 32.06666667],
      },
      properties: {
        title: 'White City of Tel-Aviv -- the Modern Movement',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.4730555556, 44.2202777778],
      },
      properties: {
        title: 'The Causses and the Cévennes, Mediterranean agro-pastoral Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-104.3833333, 32.16666667],
      },
      properties: {
        title: 'Carlsbad Caverns National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-64.30916667, 44.37611111],
      },
      properties: {
        title: 'Old Town Lunenburg',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [111.0, 32.46667],
      },
      properties: {
        title: 'Ancient Building Complex in the Wudang Mountains',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.9311111111, 44.4122222222],
      },
      properties: {
        title: 'Genoa: Le Strade Nuove and the system of the Palazzi dei Rolli',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.48167, 32.51806],
      },
      properties: {
        title: 'Ancient City of Bosra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.19625, 44.42041667],
      },
      properties: {
        title: 'Early Christian Monuments of Ravenna',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.29306, 32.63833],
      },
      properties: {
        title: 'Archaeological Site of Leptis Magna',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-110.82778, 44.46056],
      },
      properties: {
        title: 'Yellowstone National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [51.6852777778, 32.6697222222],
      },
      properties: {
        title: 'Masjed-e Jāmé of Isfahan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.92568, 44.64624],
      },
      properties: {
        title: 'Cathedral, Torre Civica and Piazza Grande, Modena',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.82222, 32.75417],
      },
      properties: {
        title: 'Huanglong Scenic and Historic Interest Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.61944444, 44.83777778],
      },
      properties: {
        title: 'Ferrara, City of the Renaissance, and its Po Delta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.485, 32.80528],
      },
      properties: {
        title: 'Archaeological Site of Sabratha',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.5722222222, 44.8388888889],
      },
      properties: {
        title: 'Bordeaux, Port of the Moon',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.9716488888, 32.8293966667],
      },
      properties: {
        title: 'Bahá’i Holy Places in Haifa and the Western Galilee',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.61444, 44.87778],
      },
      properties: {
        title: 'Plitvice Lakes National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [73.58888889, 32.9625],
      },
      properties: {
        title: 'Rohtas Fort',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.155277778, 44.89472222],
      },
      properties: {
        title: 'Jurisdiction of Saint-Emilion',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.50194, 33.25667],
      },
      properties: {
        title: 'Portuguese City of Mazagan (El Jadida)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.765125, 44.9943861111],
      },
      properties: {
        title: 'Rideau Canal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [126.7202777777, 33.4688888889],
      },
      properties: {
        title: 'Jeju Volcanic Island and Lava Tubes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.17, 45.0575],
      },
      properties: {
        title: 'Prehistoric Sites and Decorated Caves of the Vézère Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.92972, 33.72583],
      },
      properties: {
        title: 'Anjar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.68572, 45.07253],
      },
      properties: {
        title: 'Residences of the Royal House of Savoy',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [135.7763889, 33.83694444],
      },
      properties: {
        title: 'Sacred Sites and Pilgrimage Routes in the Kii Mountain Range',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.5, 45.08333],
      },
      properties: {
        title: 'Danube Delta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.20494, 34.00707],
      },
      properties: {
        title: 'Baalbek',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-64.3072222222, 45.1183333333],
      },
      properties: {
        title: 'Landscape of Grand Pré',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.97778, 34.06111],
      },
      properties: {
        title: 'Medina of Fez',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.7944444444, 45.1594444444],
      },
      properties: {
        title: 'Mantua and Sabbioneta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.6475, 34.11917],
      },
      properties: {
        title: 'Byblos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.01666667, 45.18333333],
      },
      properties: {
        title: 'Monastery of Horezu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [132.3246389, 34.29441667],
      },
      properties: {
        title: 'Itsukushima Shinto Shrine',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0.722944444, 45.18405556],
      },
      properties: {
        title: 'Routes of Santiago de Compostela in France',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [43.8235430555, 34.3409894444],
      },
      properties: {
        title: 'Samarra Archaeological City',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.59444, 45.22917],
      },
      properties: {
        title: 'Episcopal Complex of the Euphrasian Basilica in the Historic Centre of Poreč',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [132.45, 34.38333333],
      },
      properties: {
        title: 'Hiroshima Peace Memorial (Genbaku Dome)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [136.1666667, 45.33333333],
      },
      properties: {
        title: 'Central Sikhote-Alin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [64.51605556, 34.39655556],
      },
      properties: {
        title: 'Minaret and Archaeological Remains of Jam',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.88066667, 45.39911111],
      },
      properties: {
        title: 'Botanical Garden (Orto Botanico), Padua',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [112.4666667, 34.46666667],
      },
      properties: {
        title: 'Longmen Grottoes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.33894444, 45.43430556],
      },
      properties: {
        title: 'Venice and its Lagoon',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [135.7333333, 34.61666667],
      },
      properties: {
        title: 'Buddhist Monuments in the Horyu-ji Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.99388889, 45.43861111],
      },
      properties: {
        title: 'City of Verona',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [32.40556, 34.75833],
      },
      properties: {
        title: 'Paphos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.1705, 45.46588889],
      },
      properties: {
        title:
          'Church and Dominican Convent of Santa Italy Maria delle Grazie with "The Last Supper" by Leonardo da Vinci',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [33.34333, 34.79833],
      },
      properties: {
        title: 'Choirokoitia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.54944444, 45.54916667],
      },
      properties: {
        title: 'City of Vicenza and the Palladian Villas of the Veneto',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [67.82525, 34.84694],
      },
      properties: {
        title: 'Cultural Landscape and Archaeological Remains of the Bamiyan Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.53833, 45.59333],
      },
      properties: {
        title: "Crespi d'Adda",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [126.92917, 34.96667],
      },
      properties: {
        title: 'Gochang, Hwasun and Ganghwa Dolmen Sites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.31194444, 45.62305556],
      },
      properties: {
        title: 'Dacian Fortresses of the Orastie Mountains',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [132.435, 35.1127777777],
      },
      properties: {
        title: 'Iwami Ginzan Silver Mine and its Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.0, 45.66667],
      },
      properties: {
        title: 'Škocjan Caves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.63333, 35.45],
      },
      properties: {
        title: 'Timgad',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-64.4358333333, 45.7097222222],
      },
      properties: {
        title: 'Joggins Fossil Cliffs',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.36667, 35.57083],
      },
      properties: {
        title: 'Medina of Tétouan (formerly known as Titawin)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.83333, 45.76722],
      },
      properties: {
        title: 'Historic Site of Lyons',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-83.43555556, 35.59305556],
      },
      properties: {
        title: 'Great Smoky Mountains National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.3675, 45.76833333],
      },
      properties: {
        title: 'Archaeological Area and the Patriarchal Basilica of Aquileia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.10389, 35.68167],
      },
      properties: {
        title: 'Kairouan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.9138888889, 45.8888888889],
      },
      properties: {
        title: 'Monte San Giorgio',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [129.22667, 35.78889],
      },
      properties: {
        title: 'Gyeongju Historic Areas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.29733333, 45.95705556],
      },
      properties: {
        title: 'Rock Drawings in Valcamonica',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.78684, 35.81844],
      },
      properties: {
        title: "Al Qal'a of Beni Hammad",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.169555556, 45.97455556],
      },
      properties: {
        title: 'Sacri Monti of Piedmont and Lombardy',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.50739, 35.87134],
      },
      properties: {
        title: 'Hal Saflieni Hypogeum',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.0275, 46.0022222222],
      },
      properties: {
        title: 'Heritage of Mercury. Almadén and Idrija',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.26947, 36.04908],
      },
      properties: {
        title: 'Megalithic Temples of Malta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.22778, 46.07444],
      },
      properties: {
        title: 'Early Christian Necropolis of Pécs (Sopianae)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-112.0905556, 36.10083333],
      },
      properties: {
        title: 'Grand Canyon National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.4330555556, 46.0941666667],
      },
      properties: {
        title: 'Longobards in Italy. Places of the Power (568-774 A.D.)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.16667, 36.23333],
      },
      properties: {
        title: 'Ancient City of Aleppo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.77305556, 46.13583333],
      },
      properties: {
        title: 'Villages with Fortified Churches in Transylvania',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.73667, 36.32056],
      },
      properties: {
        title: 'Djémila',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.02242, 46.19314],
      },
      properties: {
        title: 'Three Castles, Defensive Wall and Ramparts of the Market-Town of Bellinzona',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.32028, 36.335],
      },
      properties: {
        title: 'Xanthos-Letoon',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.79222222, 46.21777778],
      },
      properties: {
        title: 'Historic Centre of Sighişoara',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.22028, 36.42361],
      },
      properties: {
        title: 'Dougga / Thugga',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.7461111111, 46.4919444444],
      },
      properties: {
        title: 'Lavaux, Vineyard Terraces',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-105.54167, 36.43889],
      },
      properties: {
        title: 'Taos Pueblo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.8463888889, 46.4983333333],
      },
      properties: {
        title: 'Rhaetian Railway in the Albula / Bernina Landscapes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [128.5166666667, 36.5391666667],
      },
      properties: {
        title: 'Historic Villages of Korea: Hahoe and Yangdong',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.0333333333, 46.5],
      },
      properties: {
        title: 'Swiss Alps Jungfrau-Aletsch',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [73.5, -53.1],
      },
      properties: {
        title: 'Heard and McDonald Islands',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0.86611, 46.56472],
      },
      properties: {
        title: 'Abbey Church of Saint-Savin sur Gartempe',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [167.3196111, -45.03602778],
      },
      properties: {
        title: 'Te Wahipounamu – South West New Zealand',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.1630555556, 46.6130555556],
      },
      properties: {
        title: 'The Dolomites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.928611111, -40.32472222],
      },
      properties: {
        title: 'Gough and Inaccessible Islands',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.44765, 46.62945],
      },
      properties: {
        title: 'Benedictine Convent of St John at Müstair',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.375, -34.16666667],
      },
      properties: {
        title: 'Cape Floral Region Protected Areas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-71.21055556, 46.80944444],
      },
      properties: {
        title: 'Historic District of Old Québec',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.36666667, -33.8],
      },
      properties: {
        title: 'Robben Island',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.25, 46.9166666667],
      },
      properties: {
        title: 'Swiss Tectonic Arena Sardona',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [159.0883333, -31.56555556],
      },
      properties: {
        title: 'Lord Howe Island Group',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.8763888889, 46.9375],
      },
      properties: {
        title:
          'From the Great Saltworks of Salins-les-Bains to the Royal Saltworks of Arc-et-Senans, the Production of Open-pan Salt',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.2038888888, -28.6],
      },
      properties: {
        title: 'Richtersveld Cultural and Botanical Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.45028, 46.94806],
      },
      properties: {
        title: 'Old City of Berne',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-109.45, -27.15],
      },
      properties: {
        title: 'Rapa Nui National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.3916666667, 47.0741666667],
      },
      properties: {
        title: 'City of Graz – Historic Centre and Schloss Eggenberg',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-54.13333333, -25.51805556],
      },
      properties: {
        title: 'Iguazu National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.398333333, 47.08222222],
      },
      properties: {
        title: 'Bourges Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-128.333333333, -24.3666666667],
      },
      properties: {
        title: 'Henderson Island',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.8327777778, 47.1038888889],
      },
      properties: {
        title: 'La Chaux-de-Fonds / Le Locle, Watchmaking Town Planning',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-43.2913888889, -22.9477777778],
      },
      properties: {
        title: 'Rio de Janeiro: Carioca Landscapes between the Mountain and the Sea',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.832925, 47.1040222222],
      },
      properties: {
        title: 'La Chaux-de-Fonds / Le Locle, Watchmaking Town Planning',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.3725833333, -20.5955833333],
      },
      properties: {
        title: 'Twyfelfontein or /Ui-//aes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.2075, 47.2783333333],
      },
      properties: {
        title: 'Prehistoric Pile dwellings around the Alps',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [164.5663888889, -20.4119444444],
      },
      properties: {
        title: 'Lagoons of New Caledonia: Reef Diversity and Associated Ecosystems',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0.70278, 47.39889],
      },
      properties: {
        title: 'The Loire Valley between Sully-sur-Loire and Chalonnes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [57.5031666666, -20.1586388889],
      },
      properties: {
        title: 'Aapravasi Ghat',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.37778, 47.42333],
      },
      properties: {
        title: 'Convent of St Gall',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-65.25917, -19.04306],
      },
      properties: {
        title: 'Historic City of Sucre',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.748333333, 47.46638889],
      },
      properties: {
        title: 'Vézelay, Church and Hill',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [147.7, -18.28611111],
      },
      properties: {
        title: 'Great Barrier Reef',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.07067, 47.48242],
      },
      properties: {
        title: 'Budapest, including the Banks of the Danube, the Buda Castle Quarter and Andrássy Avenue',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-57.38333, -17.71667],
      },
      properties: {
        title: 'Pantanal Conservation Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [102.8313889, 47.55666667],
      },
      properties: {
        title: 'Orkhon Valley Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-39.25, -16.5],
      },
      properties: {
        title: 'Discovery Coast Atlantic Forest Reserves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.78444, 47.55889],
      },
      properties: {
        title: 'Millenary Benedictine Abbey of Pannonhalma and its Natural Environment',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.40805556, -15.81944444],
      },
      properties: {
        title: 'Mana Pools National Park, Sapi and Chewore Safari Areas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.64638889, 47.55944444],
      },
      properties: {
        title: 'Hallstatt-Dachstein / Salzkammergut Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.14861, -14.72583],
      },
      properties: {
        title: 'Lines and Geoglyphs of Nasca and Pampas de Jumana',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.15678, 47.59458],
      },
      properties: {
        title: 'Hortobágy National Park - the Puszta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.88333, -14.03333],
      },
      properties: {
        title: 'Lake Malawi National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.38911, 47.63944],
      },
      properties: {
        title: 'Cistercian Abbey of Fontenay',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-38.5, -12.96666667],
      },
      properties: {
        title: 'Historic Centre of Salvador de Bahia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.82797222, 47.64877778],
      },
      properties: {
        title: 'Semmering Railway',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [160.33333, -11.68333],
      },
      properties: {
        title: 'East Rennell',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.90013889, 47.68127778],
      },
      properties: {
        title: 'Pilgrimage Church of Wies',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [46.41666667, -9.416666667],
      },
      properties: {
        title: 'Aldabra Atoll',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.061305556, 47.69872222],
      },
      properties: {
        title: 'Monastic Island of Reichenau',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [119.48944, -8.54333],
      },
      properties: {
        title: 'Komodo National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.72272222, 47.71927778],
      },
      properties: {
        title: 'Fertö / Neusiedlersee Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-34.845, -8.013333333],
      },
      properties: {
        title: 'Historic Centre of the Town of Olinda',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-123.4488889, 47.74833333],
      },
      properties: {
        title: 'Olympic National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [110.8166667, -7.4],
      },
      properties: {
        title: 'Sangiran Early Man Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.7127777778, 47.7783333333],
      },
      properties: {
        title: 'Churches of Moldavia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [137.83333, -4.75],
      },
      properties: {
        title: 'Lorentz National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.04333333, 47.80055556],
      },
      properties: {
        title: 'Historic Centre of the City of Salzburg',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [39.5961111111, -3.9319444444],
      },
      properties: {
        title: 'Sacred Mijikenda Kaya Forests',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.05583333, 47.82083333],
      },
      properties: {
        title: 'Wooden Churches of Maramureş',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.36667, -3.06667],
      },
      properties: {
        title: 'Kilimanjaro National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.3263888889, 47.9366666667],
      },
      properties: {
        title: 'Primeval Beech Forests of the Carpathians and the Ancient Beech Forests of Germany',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [101.5, -2.5],
      },
      properties: {
        title: 'Tropical Rainforest Heritage of Sumatra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.52917, 47.99444],
      },
      properties: {
        title: 'Old Village of Hollókő and its Surroundings',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.0, -2.0],
      },
      properties: {
        title: 'Salonga National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-66.35305556, 48.105],
      },
      properties: {
        title: 'Miguasha National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.5, -0.5],
      },
      properties: {
        title: 'Ecosystem and Relict Cultural Landscape of Lopé-Okanda',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.35, 48.15],
      },
      properties: {
        title: 'Tokaj Wine Region Historic Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.92416667, 0.223611111],
      },
      properties: {
        title: 'Rwenzori Mountains National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.31333333, 48.18666667],
      },
      properties: {
        title: 'Palace and Gardens of Schönbrunn',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [28.5, 2.0],
      },
      properties: {
        title: 'Okapi Wildlife Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.38333333, 48.21666667],
      },
      properties: {
        title: 'Historic Centre of Vienna',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.4241666667, 2.9166666667],
      },
      properties: {
        title: 'Sangha Trinational',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.9247222222, 48.2966666667],
      },
      properties: {
        title: 'Residence of Bukovinian and Dalmatian Metropolitans',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-56.5, 4.0],
      },
      properties: {
        title: 'Central Suriname Nature Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [27.8766666667, 48.3188888889],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [100.9723277778, 5.0679083333],
      },
      properties: {
        title: 'Archaeological Heritage of the Lenggong Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.43416667, 48.36444444],
      },
      properties: {
        title: 'Wachau Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.49361, 5.39103],
      },
      properties: {
        title: 'Forts and Castles, Volta, Greater Accra, Central and Western Regions',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.698055556, 48.40194444],
      },
      properties: {
        title: 'Palace and Park of Fontainebleau',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.66667, 5.75],
      },
      properties: {
        title: 'Taï National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.487222222, 48.4475],
      },
      properties: {
        title: 'Chartres Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.6258333333, 6.4011111111],
      },
      properties: {
        title: 'Asante Traditional Buildings',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.9, 48.46111],
      },
      properties: {
        title: 'Historic Town of Banská Štiavnica and the Technical Monuments in its Vicinity',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.64027778, 7.293611111],
      },
      properties: {
        title: 'Sacred City of Kandy',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.48687, 48.47573],
      },
      properties: {
        title: 'Caves of Aggtelek Karst and Slovak Karst',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.0, 7.666666667],
      },
      properties: {
        title: 'Los Katíos National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.298888889, 48.55972222],
      },
      properties: {
        title: 'Provins, Town of Medieval Fairs',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [81.00055556, 7.915833333],
      },
      properties: {
        title: 'Ancient City of Polonnaruwa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.73, 48.58138889],
      },
      properties: {
        title: 'Strasbourg – Grande île',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.2497222222, 8.5297222222],
      },
      properties: {
        title: 'Western Ghats',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.51056, 48.63556],
      },
      properties: {
        title: 'Mont-Saint-Michel and its Bay',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.5, 9.0],
      },
      properties: {
        title: 'Manovo-Gounda St Floris National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.183333333, 48.69361111],
      },
      properties: {
        title: "Place Stanislas, Place de la Carrière and Place d'Alliance in Nancy",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-79.65583333, 9.553888889],
      },
      properties: {
        title: 'Fortifications on the Caribbean Side of Panama: Portobelo-San Lorenzo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.775, 48.77583],
      },
      properties: {
        title: 'Lednice-Valtice Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.53333333, 10.41666667],
      },
      properties: {
        title: 'Port, Fortresses and Group of Monuments, Cartagena',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.119444444, 48.805],
      },
      properties: {
        title: 'Palace and Park of Versailles',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-85.61666667, 10.85],
      },
      properties: {
        title: 'Area de Conservación Guanacaste',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.31666667, 48.81666667],
      },
      properties: {
        title: 'Historic Centre of Český Krumlov',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [165.3805555556, 11.6],
      },
      properties: {
        title: 'Bikini Atoll Nuclear Test Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.294166667, 48.85833333],
      },
      properties: {
        title: 'Paris, Banks of the Seine',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-86.61028, 12.39722],
      },
      properties: {
        title: 'Ruins of León Viejo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.25277778, 48.95972222],
      },
      properties: {
        title: 'Holašovice Historical Village Reservation',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.46617, 12.60692],
      },
      properties: {
        title: 'Fasil Ghebbi, Gondar Region',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-113.9041667, 48.99605556],
      },
      properties: {
        title: 'Waterton Glacier International Peace Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.0666666667, 13.1833333333],
      },
      properties: {
        title: 'Simien National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.7675, 48.9994444444],
      },
      properties: {
        title: 'Levoča, Spišský Hrad and the Associated Cultural Monuments',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-14.8666666667, 13.7],
      },
      properties: {
        title: 'Stone Circles of Senegambia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.81306, 49.00083],
      },
      properties: {
        title: 'Maulbronn Monastery Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.555, 13.90639],
      },
      properties: {
        title: 'Old Towns of Djenné',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.09916667, 49.02055556],
      },
      properties: {
        title: 'Old town of Regensburg with Stadtamhof',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.41667, 14.33333],
      },
      properties: {
        title: 'Cliff of Bandiagara (Land of the Dogons)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.28333, 49.03333],
      },
      properties: {
        title: 'Vlkolínec',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [120.97, 14.59],
      },
      properties: {
        title: 'Baroque Churches of the Philippines',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.5361111111, 49.0861111111],
      },
      properties: {
        title: 'Primeval Beech Forests of the Carpathians and the Ancient Beech Forests of Germany',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-23.6051944444, 14.9151388889],
      },
      properties: {
        title: 'Cidade Velha, Historic Centre of Ribeira Grande',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.45, 49.18333],
      },
      properties: {
        title: 'Historic Centre of Telč',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [98.91667, 15.33333],
      },
      properties: {
        title: 'Thungyai-Huai Kha Khaeng Wildlife Sanctuaries',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.6160555556, 49.2071833333],
      },
      properties: {
        title: 'Tugendhat Villa in Brno',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-84.675, 15.74444444],
      },
      properties: {
        title: 'Río Plátano Biosphere Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.87888889, 49.21722222],
      },
      properties: {
        title: "Jewish Quarter and St Procopius' Basilica in Třebíč",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.50444, 16.02778],
      },
      properties: {
        title: 'Island of Saint-Louis',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.85, 49.24444],
      },
      properties: {
        title: 'Völklingen Ironworks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-87.05833333, 16.75],
      },
      properties: {
        title: 'Belize Barrier Reef Reserve System',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.032777778, 49.25333333],
      },
      properties: {
        title: 'Cathedral of Notre-Dame, Former Abbey of Saint-Rémi and Palace of Tau, Reims',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-96.4211111111, 16.9508333333],
      },
      properties: {
        title: 'Prehistoric Caves of Yagul and Mitla in the Central Valley of Oaxaca',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.27917, 49.29333],
      },
      properties: {
        title: 'Bardejov Town Conservation Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-62.83722, 17.34694],
      },
      properties: {
        title: 'Brimstone Hill Fortress National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.37722222, 49.3],
      },
      properties: {
        title: 'Gardens and Castle at Kroměříž',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [120.3875, 17.575],
      },
      properties: {
        title: 'Historic Town of Vigan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.443055556, 49.31666667],
      },
      properties: {
        title: 'Speyer Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-66.125, 18.46666667],
      },
      properties: {
        title: 'La Fortaleza and San Juan National Historic Site in Puerto Rico',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [88.3952777778, 49.3338888889],
      },
      properties: {
        title: 'Petroglyphic Complexes of the Mongolian Altai',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-99.275, 18.81028],
      },
      properties: {
        title: 'Archaeological Monuments Zone of Xochicalco',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.5583333333, 49.3361111111],
      },
      properties: {
        title: 'Wooden Churches of the Slovak part of the Carpathian Mountain Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-98.20833, 19.04722],
      },
      properties: {
        title: 'Historic Centre of Puebla',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0.1075, 49.49278],
      },
      properties: {
        title: 'Le Havre, the City Rebuilt by Auguste Perret',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-155.1236111, 19.40083333],
      },
      properties: {
        title: 'Hawaii Volcanoes National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.7561111111, 49.5658333333],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-100.2416666667, 19.6063888889],
      },
      properties: {
        title: 'Monarch Butterfly Biosphere Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.9420583333, 49.5802],
      },
      properties: {
        title: 'Pilgrimage Church of St John of Nepomuk at Zelená Hora',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-90.53722, 19.84639],
      },
      properties: {
        title: 'Historic Fortified Town of Campeche',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.2504583333, 49.5939361111],
      },
      properties: {
        title: 'Holy Trinity Column in Olomouc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.87083333, 19.96666667],
      },
      properties: {
        title: 'San Pedro de la Roca Castle, Santiago de Cuba',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.13333, 49.61],
      },
      properties: {
        title: 'City of Luxembourg: its Old Quarters and Fortifications',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [105.6047222222, 20.0780555556],
      },
      properties: {
        title: 'Citadel of the Ho Dynasty',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-57.53138889, 49.6125],
      },
      properties: {
        title: 'Gros Morne National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-97.3775, 20.47639],
      },
      properties: {
        title: 'El Tajin, Pre-Hispanic City',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.56858, 49.65369],
      },
      properties: {
        title: 'Abbey and Altenmünster of Lorsch',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-103.3397222, 20.67388889],
      },
      properties: {
        title: 'Hospicio Cabañas, Guadalajara',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-113.6238889, 49.74944444],
      },
      properties: {
        title: 'Head-Smashed-In Buffalo Jump',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-11.62361, 20.92889],
      },
      properties: {
        title: 'Ancient Ksour of Ouadane, Chinguetti, Tichitt and Oualata',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.633333333, 49.75],
      },
      properties: {
        title: 'Roman Monuments, Cathedral of St Peter and Church of Our Lady in Trier',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.9186111111, 21.3786111111],
      },
      properties: {
        title: 'Historic Centre of Camagüey',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.23333333, 49.75],
      },
      properties: {
        title: 'Wooden Churches of Southern Little Poland',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-80.45278, 22.14722],
      },
      properties: {
        title: 'Urban Historic Centre of Cienfuegos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.93889, 49.79278],
      },
      properties: {
        title: 'Würzburg Residence with the Court Gardens and Residence Square',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [73.53333333, 22.48333333],
      },
      properties: {
        title: 'Champaner-Pavagadh Archaeological Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.03198, 49.84163],
      },
      properties: {
        title: "L'viv – the Ensemble of the Historic Centre",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-102.55556, 22.76667],
      },
      properties: {
        title: 'Historic Centre of Zacatecas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.66666667, 49.86666667],
      },
      properties: {
        title: 'Kalwaria Zebrzydowska: the Mannerist Architectural and Park Landscape Complex and Pilgrimage Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-82.35, 23.13333333],
      },
      properties: {
        title: 'Old Havana and its Fortifications',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.31444, 49.87361],
      },
      properties: {
        title: 'Litomyšl Castle',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [102.9772222222, 24.6688888889],
      },
      properties: {
        title: 'Chengjiang Fossil Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.88888889, 49.89166667],
      },
      properties: {
        title: 'Town of Bamberg',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.33333, 24.83333],
      },
      properties: {
        title: 'Rock-Art Sites of Tadrart Acacus',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.301666667, 49.895],
      },
      properties: {
        title: 'Amiens Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [107.975, 25.2208333333],
      },
      properties: {
        title: 'South China Karst',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.75389, 49.91667],
      },
      properties: {
        title: 'Messel Pit Fossil Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [32.6, 25.73333],
      },
      properties: {
        title: 'Ancient Thebes with its Necropolis',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.5786111111, 49.9444444444],
      },
      properties: {
        title: 'Margravial Opera House Bayreuth',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [93.41666667, 26.66666667],
      },
      properties: {
        title: 'Kaziranga National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.2666666667, 49.95],
      },
      properties: {
        title:
          'Kutná Hora: Historical Town Centre with the Church of St Barbara and the Cathedral of Our Lady at Sedlec',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [75.825, 26.9247222222],
      },
      properties: {
        title: 'The Jantar Mantar, Jaipur',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.06389, 49.97917],
      },
      properties: {
        title: 'Wieliczka Salt Mine',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [78.03333333, 27.18333333],
      },
      properties: {
        title: 'Agra Fort',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.175, 50.0388888889],
      },
      properties: {
        title: 'Auschwitz Birkenau German Nazi Concentration and Extermination Camp (1940-1945)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-112.54583, 27.62667],
      },
      properties: {
        title: 'Islands and Protected Areas of the Gulf of California',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.95972, 50.06667],
      },
      properties: {
        title: "Cracow's Historic Centre",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [142.0997222222, 27.7183333333],
      },
      properties: {
        title: 'Ogasawara Islands',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.41944, 50.08972],
      },
      properties: {
        title: 'Historic Centre of Prague',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-17.23722222, 28.12625],
      },
      properties: {
        title: 'Garajonay National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.3836111111, 50.1361111111],
      },
      properties: {
        title: 'Cornwall and West Devon Mining Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.18528, 28.52583],
      },
      properties: {
        title: 'Qutb Minar and its Monuments, Delhi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.694166667, 50.17361111],
      },
      properties: {
        title: 'Upper Middle Rhine Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [118.0644444444, 28.9158333333],
      },
      properties: {
        title: 'Mount Sanqingshan National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.23139, 50.17444],
      },
      properties: {
        title: 'Belfries of Belgium and France',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [115.8666667, 29.43333333],
      },
      properties: {
        title: 'Lushan National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [92.71972222, 50.275],
      },
      properties: {
        title: 'Uvs Nuur Basin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [105.705, 29.70111],
      },
      properties: {
        title: 'Dazu Rock Carvings',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.7588888889, 50.2825],
      },
      properties: {
        title: 'Fortifications of Vauban',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [31.26111, 30.05],
      },
      properties: {
        title: 'Historic Cairo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.4440555556, 50.4118055556],
      },
      properties: {
        title: 'Belfries of Belgium and France',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [53.16729, 30.19383],
      },
      properties: {
        title: 'Pasargadae',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.97879, 50.43077],
      },
      properties: {
        title: 'Neolithic Flint Mines at Spiennes (Mons)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-107.95556, 30.37583],
      },
      properties: {
        title: 'Archaeological Zone of Paquimé, Casas Grandes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [69.1888888889, 50.4333333333],
      },
      properties: {
        title: 'Saryarka – Steppe and Lakes of Northern Kazakhstan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.66666667, 30.85],
      },
      properties: {
        title: 'Abu Mena',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.8383333333, 50.4352777778],
      },
      properties: {
        title: 'Major Mining Sites of Wallonia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [120.45, 31.31666667],
      },
      properties: {
        title: 'Classical Gardens of Suzhou',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [30.51686, 50.45258],
      },
      properties: {
        title: 'Kiev: Saint-Sophia Cathedral and Related Monastic Buildings, Kiev-Pechersk Lavra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.98667, 31.63139],
      },
      properties: {
        title: 'Medina of Marrakesh',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.5461111111, 50.4625],
      },
      properties: {
        title: 'Nord-Pas de Calais Mining Basin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [48.8358333333, 32.0186111111],
      },
      properties: {
        title: 'Shushtar Historical Hydraulic System',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [86.0, 50.46666667],
      },
      properties: {
        title: 'Golden Mountains of Altai',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-64.67777778, 32.37944444],
      },
      properties: {
        title: 'Historic Town of St George and Related Fortifications, Bermuda',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.13722, 50.48111],
      },
      properties: {
        title: 'The Four Lifts on the Canal du Centre and their Environs, La Louvière and Le Roeulx (Hainaut)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.18222, 32.59722],
      },
      properties: {
        title: 'Biblical Tels - Megiddo, Hazor, Beer Sheba',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.38926, 50.60603],
      },
      properties: {
        title: 'Notre-Dame Cathedral in Tournai',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.9652777778, 32.67],
      },
      properties: {
        title: 'Sites of Human Evolution at Mount Carmel: The Nahal Me’arot / Wadi el-Mughara Caves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.989888889, 50.70555556],
      },
      properties: {
        title: 'Dorset and East Devon Coast',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.85833, 32.825],
      },
      properties: {
        title: 'Archaeological Site of Cyrene',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.26667, 50.71667],
      },
      properties: {
        title: 'Old City of Zamość',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.91667, 33.08333],
      },
      properties: {
        title: 'Jiuzhaigou Valley Scenic and Historic Interest Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-111.4922222, 50.76777778],
      },
      properties: {
        title: 'Dinosaur Provincial Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.30639, 33.51139],
      },
      properties: {
        title: 'Ancient City of Damascus',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.084444444, 50.77444444],
      },
      properties: {
        title: 'Aachen Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.55833, 33.88333],
      },
      properties: {
        title: 'Historic City of Meknes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.909777778, 50.82502778],
      },
      properties: {
        title: 'Castles of Augustusburg and Falkenlust at Brühl',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.55694, 34.07389],
      },
      properties: {
        title: 'Archaeological Site of Volubilis',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.36223, 50.82806],
      },
      properties: {
        title: 'Major Town Houses of the Architect Victor Horta (Brussels)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [71.94583333, 34.32083333],
      },
      properties: {
        title: 'Buddhist Ruins of Takht-i-Bahi and Neighbouring City Remains at Sahr-i-Bahlol',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.4161111111, 50.835],
      },
      properties: {
        title: 'Stoclet House',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [47.4366666666, 34.3883333333],
      },
      properties: {
        title: 'Bisotun',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.35242, 50.84668],
      },
      properties: {
        title: 'La Grand-Place, Brussels',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.26667, 34.55417],
      },
      properties: {
        title: 'Site of Palmyra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [6.957222222, 50.94111111],
      },
      properties: {
        title: 'Cologne Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.2630555555, 34.7816666667],
      },
      properties: {
        title: 'Crac des Chevaliers and Qal’at Salah El-Din',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.307, 50.96677778],
      },
      properties: {
        title: 'Wartburg Castle',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [33.09583333, 34.92027778],
      },
      properties: {
        title: 'Painted Churches in the Troodos Region',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.32949, 50.97477],
      },
      properties: {
        title: 'Bauhaus and its Sites in Weimar and Dessau',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.70694, 35.29639],
      },
      properties: {
        title: 'Amphitheatre of El Jem',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.32861, 50.9775],
      },
      properties: {
        title: 'Classical Weimar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [42.71833, 35.58806],
      },
      properties: {
        title: 'Hatra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.47375, 51.03097222],
      },
      properties: {
        title: 'Flemish Béguinages',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [129.35, 35.78333333],
      },
      properties: {
        title: 'Seokguram Grotto and Bulguksa Temple',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.82111111, 51.04],
      },
      properties: {
        title: 'Dresden Elbe Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.63861, 35.82778],
      },
      properties: {
        title: 'Medina of Sousse',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.19594444, 51.05427778],
      },
      properties: {
        title: 'Churches of Peace in Jawor and Świdnica',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-107.9708333, 36.06377778],
      },
      properties: {
        title: 'Chaco Culture',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.0770138888, 51.1069472222],
      },
      properties: {
        title: 'Centennial Hall in Wrocław',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [117.1, 36.26667],
      },
      properties: {
        title: 'Mount Taishan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.825277778, 51.17888889],
      },
      properties: {
        title: 'Stonehenge, Avebury and Associated Sites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [136.8833333, 36.4],
      },
      properties: {
        title: 'Historic Villages of Shirakawa-go and Gokayama',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.22527, 51.20891],
      },
      properties: {
        title: 'Historic Centre of Brugge',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [28.22778, 36.44722],
      },
      properties: {
        title: 'Medieval City of Rhodes',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.39778, 51.21833],
      },
      properties: {
        title: 'Plantin-Moretus House-Workshops-Museum Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-73.24944, -50.0],
      },
      properties: {
        title: 'Los Glaciares National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.083333333, 51.28],
      },
      properties: {
        title: "Canterbury Cathedral, St Augustine's Abbey, and St Martin's Church",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [144.9702778, -37.80611111],
      },
      properties: {
        title: 'Royal Exhibition Building and Carlton Gardens',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.358611111, 51.38138889],
      },
      properties: {
        title: 'City of Bath',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [150.9944444444, -33.3783333333],
      },
      properties: {
        title: 'Australian Convict Sites',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-116.4797222, 51.42472222],
      },
      properties: {
        title: 'Canadian Rocky Mountain Parks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [150.05, -28.25],
      },
      properties: {
        title: 'Gondwana Rainforests of Australia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-55.61666667, 51.46666667],
      },
      properties: {
        title: 'L’Anse aux Meadows National Historic Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [131.0, -25.33333333],
      },
      properties: {
        title: 'Uluru-Kata Tjuta National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0e-10, 51.47777778],
      },
      properties: {
        title: 'Maritime Greenwich',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.23889, -22.1925],
      },
      properties: {
        title: 'Mapungubwe Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.294027778, 51.48194444],
      },
      properties: {
        title: 'Royal Botanic Gardens, Kew',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [30.93333333, -20.28333333],
      },
      properties: {
        title: 'Great Zimbabwe National Monument',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.046111111, 51.49138889],
      },
      properties: {
        title: 'Zollverein Coal Mine Industrial Complex in Essen',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.73333333, -18.75],
      },
      properties: {
        title: 'Tsodilo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.128611111, 51.49972222],
      },
      properties: {
        title: "Westminster Palace, Westminster Abbey and Saint Margaret's Church",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [128.5, -17.5],
      },
      properties: {
        title: 'Purnululu National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.076111111, 51.50805556],
      },
      properties: {
        title: 'Tower of London',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [144.9666667, -15.65],
      },
      properties: {
        title: 'Wet Tropics of Queensland',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.72644444, 51.57930556],
      },
      properties: {
        title: 'Muskauer Park / Park Mużakowski',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-71.98333, -13.52222],
      },
      properties: {
        title: 'City of Cuzco',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-10.53861, 51.77194],
      },
      properties: {
        title: 'Sceilg Mhichíl',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.5213888889, -10.8916666667],
      },
      properties: {
        title: 'Sacred City of Caral-Supe',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.088055556, 51.77638889],
      },
      properties: {
        title: 'Blaenavon Industrial Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [115.4027777778, -8.2591666667],
      },
      properties: {
        title:
          'Cultural Landscape of Bali Province: the Subak System as a Manifestation of the Tri Hita Karana Philosophy',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.15, 51.78333],
      },
      properties: {
        title: 'Collegiate Church, Castle and Old Town of Quedlinburg',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [39.18917, -6.16306],
      },
      properties: {
        title: 'Stone Town of Zanzibar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.34, 51.82],
      },
      properties: {
        title: 'Mines of Rammelsberg, Historic Town of Goslar and Upper Harz Water Management System',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-172.8575, -3.6497222222],
      },
      properties: {
        title: 'Phoenix Islands Protected Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.361388889, 51.84194444],
      },
      properties: {
        title: 'Blenheim Palace',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.56667, -2.33333],
      },
      properties: {
        title: 'Serengeti National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.42083, 51.8425],
      },
      properties: {
        title: 'Garden Kingdom of Dessau-Wörlitz',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.33666667, -0.123888889],
      },
      properties: {
        title: 'Mount Kenya National Park/Natural Forest',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.65278, 51.86472],
      },
      properties: {
        title: 'Luther Memorials in Eisleben and Wittenberg',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-76.03333333, 2.583333333],
      },
      properties: {
        title: 'National Archeological Park of Tierradentro',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.649444444, 51.8825],
      },
      properties: {
        title: 'Mill Network at Kinderdijk-Elshout',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [114.91667, 4.13333],
      },
      properties: {
        title: 'Gunung Mulu National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.8111111111, 51.9836111111],
      },
      properties: {
        title: 'Fagus Factory in Alfeld',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-75.6816666667, 5.4716666667],
      },
      properties: {
        title: 'Coffee Cultural Landscape of Colombia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.147222222, 52.08527778],
      },
      properties: {
        title: 'Rietveld Schröderhuis (Rietveld Schröder House)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [1.983333333, 7.183333333],
      },
      properties: {
        title: 'Royal Palaces of Abomey',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-131.2202778, 52.095],
      },
      properties: {
        title: 'SGang Gwaay',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.55222, 7.75556],
      },
      properties: {
        title: 'Osun-Osogbo Sacred Grove',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.94389, 52.15278],
      },
      properties: {
        title: "St Mary's Cathedral and St Michael's Church at Hildesheim",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [119.8675, 8.9533333333],
      },
      properties: {
        title: 'Tubbataha Reefs Natural Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.01167, 52.26639],
      },
      properties: {
        title: 'Historic Centre of Warsaw',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [118.9166667, 10.16666667],
      },
      properties: {
        title: 'Puerto-Princesa Subterranean River National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.8877777778, 52.365],
      },
      properties: {
        title: 'Seventeenth-century canal ring area of Amsterdam inside the Singelgracht',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-69.68333333, 11.4],
      },
      properties: {
        title: 'Coro and its Port',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.893055556, 52.37444444],
      },
      properties: {
        title: 'Defence Line of Amsterdam',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [53.8333333333, 12.5],
      },
      properties: {
        title: 'Socotra Archipelago',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.03333333, 52.4],
      },
      properties: {
        title: 'Palaces and Parks of Potsdam and Berlin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [103.8333333, 13.43333333],
      },
      properties: {
        title: 'Angkor',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.45, 52.4483333333],
      },
      properties: {
        title: 'Berlin Modernism Housing Estates',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [43.33, 14.19806],
      },
      properties: {
        title: 'Historic Town of Zabid',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.58333333, 52.5],
      },
      properties: {
        title: 'Belovezhskaya Pushcha / Białowieża Forest',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [105.8222222222, 14.8483333333],
      },
      properties: {
        title: 'Vat Phou and Associated Ancient Settlements within the Champasak Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.39861111, 52.51972222],
      },
      properties: {
        title: 'Museumsinsel (Museum Island), Berlin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [73.91167, 15.50222],
      },
      properties: {
        title: 'Churches and Convents of Goa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [4.911111111, 52.54888889],
      },
      properties: {
        title: 'Droogmakerij de Beemster (Beemster Polder)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [107.57778, 16.46944],
      },
      properties: {
        title: 'Complex of Hué Monuments',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.472777778, 52.62638889],
      },
      properties: {
        title: 'Ironbridge Gorge',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-96.72167, 17.06194],
      },
      properties: {
        title: 'Historic Centre of Oaxaca and Archaeological Site of Monte Albán',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.771666667, 52.63861111],
      },
      properties: {
        title: 'Schokland and Surroundings',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-89.78333, 18.1225],
      },
      properties: {
        title: 'Ancient Maya City of Calakmul, Campeche',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.67889, 52.84583],
      },
      properties: {
        title: 'Ir.D.F. Woudagemaal (D.F. Wouda Steam Pumping Station)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [72.8362027777, 18.9401222222],
      },
      properties: {
        title: 'Chhatrapati Shivaji Terminus (formerly Victoria Terminus)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.0877777778, 52.9702777778],
      },
      properties: {
        title: 'Pontcysyllte Aqueduct and Canal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-99.19833333, 19.41833333],
      },
      properties: {
        title: 'Luis Barragán House and Studio',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.61944, 53.01],
      },
      properties: {
        title: 'Medieval Town of Toruń',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [86.09472, 19.8875],
      },
      properties: {
        title: 'Sun Temple, Konârak',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.488055556, 53.02888889],
      },
      properties: {
        title: 'Derwent Valley Mills',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-89.77027778, 20.36166667],
      },
      properties: {
        title: 'Pre-Hispanic Town of Uxmal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.807472222, 53.07597222],
      },
      properties: {
        title: 'Town Hall and Roland on the Marketplace of Bremen',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [107.1, 20.9],
      },
      properties: {
        title: 'Ha Long Bay',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-4.276944444, 53.13972222],
      },
      properties: {
        title: 'Castles and Town Walls of King Edward in Gwynedd',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [88.89583333, 21.945],
      },
      properties: {
        title: 'Sundarbans National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [107.6625, 53.17361111],
      },
      properties: {
        title: 'Lake Baikal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-83.71667, 22.61667],
      },
      properties: {
        title: 'Viñales Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.69139, 53.22278],
      },
      properties: {
        title: 'Architectural, Residential and Cultural Complex of the Radziwill Family at Nesvizh',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.73972, 23.47944],
      },
      properties: {
        title: 'Buddhist Monuments at Sanchi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.6658333333, 53.3908333333],
      },
      properties: {
        title: 'The Wadden Sea',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [117.6858333333, 25.0230555556],
      },
      properties: {
        title: 'Fujian Tulou',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.994444444, 53.40666667],
      },
      properties: {
        title: 'Liverpool – Maritime Mercantile City',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [50.52222, 26.23306],
      },
      properties: {
        title: 'Qal’at al-Bahrain – Ancient Harbour and Capital of Dilmun',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.47272222, 53.45108333],
      },
      properties: {
        title: 'Mir Castle Complex',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.50861111, 27.15888889],
      },
      properties: {
        title: 'Keoladeo National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [8.5561111111, 53.5286111111],
      },
      properties: {
        title: 'The Wadden Sea',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [85.30858, 27.70395],
      },
      properties: {
        title: 'Kathmandu Valley',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.45, 53.69167],
      },
      properties: {
        title: 'Archaeological Ensemble of the Bend of the Boyne',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [106.0425, 28.4219444444],
      },
      properties: {
        title: 'China Danxia',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.788333333, 53.83916667],
      },
      properties: {
        title: 'Saltaire',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [30.18333, 29.33333],
      },
      properties: {
        title: 'Wadi Al-Hitan (Whale Valley)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [10.69167, 53.86667],
      },
      properties: {
        title: 'Hanseatic City of Lübeck',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [52.89028, 29.93444],
      },
      properties: {
        title: 'Persepolis',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [19.03333333, 54.04166667],
      },
      properties: {
        title: 'Castle of the Teutonic Order in Malbork',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.44333, 30.33056],
      },
      properties: {
        title: 'Petra',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.573055556, 54.11611111],
      },
      properties: {
        title: 'Studley Royal Park including the Ruins of Fountains Abbey',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.12889, 31.04722],
      },
      properties: {
        title: 'Ksar of Ait-Ben-Haddou',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.0452777778, 54.2916666667],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.21666667, 31.78333333],
      },
      properties: {
        title: 'Old City of Jerusalem and its Walls',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.08527778, 54.3025],
      },
      properties: {
        title: 'Historic Centres of Stralsund and Wismar',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [3.68333, 32.48333],
      },
      properties: {
        title: "M'Zab Valley",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.29306, 54.68667],
      },
      properties: {
        title: 'Vilnius Historic Centre',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-17.0, 32.76666667],
      },
      properties: {
        title: 'Laurisilva of Madeira',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-1.576111111, 54.77472222],
      },
      properties: {
        title: 'Durham Castle and Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.19444, 33.27194],
      },
      properties: {
        title: 'Tyre',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.83055556, 54.88777778],
      },
      properties: {
        title: 'Kernavė Archaeological Site (Cultural Reserve of Kernavė)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.8227777778, 34.0241666667],
      },
      properties: {
        title: 'Rabat, Modern Capital and Historic City: a Shared Heritage',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-2.601, 54.9926111111],
      },
      properties: {
        title: 'Frontiers of the Roman Empire',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [109.1, 34.38333333],
      },
      properties: {
        title: 'Mausoleum of the First Qin Emperor',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.485277778, 55.25],
      },
      properties: {
        title: "Giant's Causeway and Causeway Coast",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [135.8394444, 34.67555556],
      },
      properties: {
        title: 'Historic Monuments of Ancient Nara',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [20.96239, 55.27458],
      },
      properties: {
        title: 'Curonian Spit',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [135.7694444, 34.98055556],
      },
      properties: {
        title: 'Historic Monuments of Ancient Kyoto (Kyoto, Uji and Otsu Cities)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.07972222, 55.64222222],
      },
      properties: {
        title: 'Roskilde Cathedral',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [116.975, 35.61167],
      },
      properties: {
        title: 'Temple and Cemetery of Confucius and the Kong Family Mansion in Qufu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.67389, 55.65556],
      },
      properties: {
        title: 'Church of the Ascension, Kolomenskoye',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [14.51444, 35.90056],
      },
      properties: {
        title: 'City of Valletta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.783055556, 55.66333333],
      },
      properties: {
        title: 'New Lanark',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.8441666667, 36.3341666667],
      },
      properties: {
        title: 'Ancient Villages of Northern Syria',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.55508333, 55.72611111],
      },
      properties: {
        title: 'Ensemble of the Novodevichy Convent',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [2.383333333, 36.55],
      },
      properties: {
        title: 'Tipasa',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.62972, 55.74583],
      },
      properties: {
        title: 'Kremlin and Red Square, Moscow',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [143.0, -34.0],
      },
      properties: {
        title: 'Willandra Lakes Region',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.42, 55.75638889],
      },
      properties: {
        title: 'Jelling Mounds, Runic Stones and Church',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [27.26, -26.86],
      },
      properties: {
        title: 'Vredefort Dome',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [49.095, 55.79111111],
      },
      properties: {
        title: 'Historic and Architectural Complex of the Kazan Kremlin',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-43.85777778, -20.49972222],
      },
      properties: {
        title: 'Sanctuary of Bom Jesus do Congonhas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.4366666667, 55.9025],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-63.81666667, -18.16666667],
      },
      properties: {
        title: 'Fuerte de Samaipata',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.216666667, 55.95],
      },
      properties: {
        title: 'Old and New Towns of Edinburgh',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [34.2791666666, -14.2933333333],
      },
      properties: {
        title: 'Chongoni Rock-Art Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.62083333, 56.03889],
      },
      properties: {
        title: 'Kronborg Castle',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.4, -9.0],
      },
      properties: {
        title: 'Selous Game Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [40.41666667, 56.15],
      },
      properties: {
        title: 'White Monuments of Vladimir and Suzdal',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [55.7375, -4.32917],
      },
      properties: {
        title: 'Vallée de Mai Nature Reserve',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.58333, 56.16667],
      },
      properties: {
        title: 'Naval Port of Karlskrona',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.66138889, -1.080555556],
      },
      properties: {
        title: 'Bwindi Impenetrable National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.1312, 56.31035],
      },
      properties: {
        title: 'Architectural Ensemble of the Trinity Sergius Lavra in Sergiev Posad',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.50366667, 3.051305556],
      },
      properties: {
        title: 'Lake Turkana National Parks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.48333, 56.325],
      },
      properties: {
        title: 'Agricultural Landscape of Southern Öland',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.21861111, 6.021388889],
      },
      properties: {
        title: 'Old Town of Galle and its Fortifications',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [158.5, 56.33333333],
      },
      properties: {
        title: 'Volcanoes of Kamchatka',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.38333333, 8.333333333],
      },
      properties: {
        title: 'Sacred City of Anuradhapura',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.6366666667, 56.84],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [13.57194, 10.74056],
      },
      properties: {
        title: 'Sukur Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.11667, 56.95417],
      },
      properties: {
        title: 'Historic Centre of Riga',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-12.71667, 13.06667],
      },
      properties: {
        title: 'Niokolo-Koba National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [12.38333333, 57.1],
      },
      properties: {
        title: 'Varberg Radio Station',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [104.6838888889, 14.3883333333],
      },
      properties: {
        title: 'Temple of Preah Vihear',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.29583, 57.64167],
      },
      properties: {
        title: 'Hanseatic Town of Visby',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [48.62667, 15.92694],
      },
      properties: {
        title: 'Old Walled City of Shibam',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [39.87611, 57.65278],
      },
      properties: {
        title: 'Historical Centre of the City of Yaroslavl',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [106.15125, 17.53722222],
      },
      properties: {
        title: 'Phong Nha-Ke Bang National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.576666667, 57.81722222],
      },
      properties: {
        title: 'St Kilda',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-99.1880555555, 19.3322222222],
      },
      properties: {
        title: 'Central University City Campus of the Universidad Nacional Autónoma de México (UNAM)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [31.28333, 58.53333],
      },
      properties: {
        title: 'Historic Monuments of Novgorod and Surroundings',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [75.17917, 20.02639],
      },
      properties: {
        title: 'Ellora Caves',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.34111, 58.70111],
      },
      properties: {
        title: 'Rock Carvings in Tanum',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [105.8372222222, 21.0394444444],
      },
      properties: {
        title: 'Central Sector of the Imperial Citadel of Thang Long - Hanoi',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.188666667, 58.99605556],
      },
      properties: {
        title: 'Heart of Neolithic Orkney',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [57.30111, 22.96417],
      },
      properties: {
        title: 'Bahla Fort',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.3377777777, 59.0577777778],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [9.0, 25.5],
      },
      properties: {
        title: "Tassili n'Ajjer",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.09944, 59.27556],
      },
      properties: {
        title: 'Skogskyrkogården',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [83.27611, 27.46889],
      },
      properties: {
        title: 'Lumbini, the Birthplace of the Lord Buddha',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.88333, 59.32306],
      },
      properties: {
        title: 'Royal Domain of Drottningholm',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [77.25056, 28.59333],
      },
      properties: {
        title: "Humayun's Tomb, Delhi",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.54264, 59.33514],
      },
      properties: {
        title: 'Birka and Hovgården',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [53.1666666667, 30.1666666667],
      },
      properties: {
        title: 'The Persian Garden',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-112.2933333, 59.35833333],
      },
      properties: {
        title: 'Wood Buffalo National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.76944, 31.51667],
      },
      properties: {
        title: 'Medina of Essaouira (formerly Mogador)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.73333333, 59.43333],
      },
      properties: {
        title: 'Historic Centre (Old Town) of Tallinn',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [51.6777777777, 32.65745],
      },
      properties: {
        title: 'Meidan Emam, Esfahan',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [30.31833, 59.95],
      },
      properties: {
        title: 'Historic Centre of Saint Petersburg and Related Groups of Monuments',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [72.8875, 33.77916667],
      },
      properties: {
        title: 'Taxila',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [38.56666667, 59.95],
      },
      properties: {
        title: 'Ensemble of the Ferrapontov Monastery',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [113.0677194444, 34.4587472222],
      },
      properties: {
        title: 'Historic Monuments of Dengfeng in “The Centre of Heaven and Earth”',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.00833, 59.96667],
      },
      properties: {
        title: 'Engelsberg Ironworks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [43.25972, 35.45889],
      },
      properties: {
        title: "Ashur (Qal'at Sherqat)",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.9697222222, 60.0741666667],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [114.3138888888, 36.1266666666],
      },
      properties: {
        title: 'Yin Xu',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [24.98722, 60.14722],
      },
      properties: {
        title: 'Fortress of Suomenlinna',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-64.0, -42.5],
      },
      properties: {
        title: 'Península Valdés',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [5.32306, 60.39722],
      },
      properties: {
        title: 'Bryggen',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.17694, -24.15861],
      },
      properties: {
        title: 'Fossil Hominid Sites of Sterkfontein, Swartkrans, Kromdraai, and Environs',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [15.63083, 60.60472],
      },
      properties: {
        title: 'Mining Area of the Great Copper Mountain in Falun',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-60.5, -16.0],
      },
      properties: {
        title: 'Jesuit Missions of the Chiquitos',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [127.0, 60.6666666667],
      },
      properties: {
        title: 'Lena Pillars Nature Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-77.25, -7.75],
      },
      properties: {
        title: 'Río Abiseo National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [26.64083, 61.06194],
      },
      properties: {
        title: 'Verla Groundwood and Board Mill',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [29.16666667, 0.916666667],
      },
      properties: {
        title: 'Virunga National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.7775, 61.12056],
      },
      properties: {
        title: 'Bronze Age Burial Site of Sammallahdenmäki',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [80.8021, 7.45245],
      },
      properties: {
        title: 'Central Highlands of Sri Lanka',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.51167, 61.12806],
      },
      properties: {
        title: 'Old Rauma',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-68.90222, 12.10194],
      },
      properties: {
        title: 'Historic Area of Willemstad, Inner City and Harbour, Curaçao',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-140.9919722, 61.19758333],
      },
      properties: {
        title: 'Kluane / Wrangell-St. Elias / Glacier Bay / Tatshenshini-Alsek',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-89.04025, 15.27059],
      },
      properties: {
        title: 'Archaeological Park and Ruins of Quirigua',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.33333, 61.3],
      },
      properties: {
        title: 'Urnes Stave Church',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [31.81666667, 18.53333333],
      },
      properties: {
        title: 'Gebel Barkal and the Sites of the Napatan Region',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-125.5894444, 61.54722222],
      },
      properties: {
        title: 'Nahanni National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-100.3666667, 20.58333333],
      },
      properties: {
        title: 'Historic Monuments Zone of Querétaro',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [16.1958333333, 61.7072222222],
      },
      properties: {
        title: 'Decorated Farmhouses of Hälsingland',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [46.5724666667, 24.7341333333],
      },
      properties: {
        title: "At-Turaif District in ad-Dir'iyah",
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.2275, 62.07138889],
      },
      properties: {
        title: 'Kizhi Pogost',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [98.40638889, 27.895],
      },
      properties: {
        title: 'Three Parallel Rivers of Yunnan Protected Areas',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [7.16667, 62.11667],
      },
      properties: {
        title: 'West Norwegian Fjords – Geirangerfjord and Nærøyfjord',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [79.66667, 30.71667],
      },
      properties: {
        title: 'Nanda Devi and Valley of Flowers National Parks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [25.18333, 62.25],
      },
      properties: {
        title: 'Petäjävesi Old Church',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.08388889, 32.92833333],
      },
      properties: {
        title: 'Old City of Acre',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.3855555556, 62.5738888889],
      },
      properties: {
        title: 'Røros Mining Town and the Circumference',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [134.7, 34.83333333],
      },
      properties: {
        title: 'Himeji-jo',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [18.5, 63.0],
      },
      properties: {
        title: 'High Coast / Kvarken Archipelago',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [48.79667, 36.43528],
      },
      properties: {
        title: 'Soltaniyeh',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [21.3, 63.3],
      },
      properties: {
        title: 'High Coast / Kvarken Archipelago',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-65.75306, -19.58361],
      },
      properties: {
        title: 'City of Potosí',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-20.6022222222, 63.3030555556],
      },
      properties: {
        title: 'Surtsey',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-44.3025, -2.514166667],
      },
      properties: {
        title: 'Historic Centre of São Luís',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-21.03725, 64.25380556],
      },
      properties: {
        title: 'Þingvellir National Park',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [42.1377777777, 9.3088888888],
      },
      properties: {
        title: 'Harar Jugol, the Fortified Historic Town',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [60.15, 65.06667],
      },
      properties: {
        title: 'Virgin Komi Forests',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [33.7166666667, 16.9333333333],
      },
      properties: {
        title: 'Archaeological Sites of the Island of Meroe',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.66666667, 65.08333333],
      },
      properties: {
        title: 'Cultural and Historic Ensemble of the Solovetsky Islands',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [112.5658611111, 22.2855194444],
      },
      properties: {
        title: 'Kaiping Diaolou and Villages',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [11.75, 65.61667],
      },
      properties: {
        title: 'Vegaøyan -- The Vega Archipelago',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [35.4338888889, 29.6397222222],
      },
      properties: {
        title: 'Wadi Rum Protected Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.02861, 65.64611],
      },
      properties: {
        title: 'Church Village of Gammelstad, Luleå',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [36.04889, 34.24333],
      },
      properties: {
        title: 'Ouadi Qadisha (the Holy Valley) and the Forest of the Cedars of God (Horsh Arz el-Rab)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [17.58333, 67.33333],
      },
      properties: {
        title: 'Laponian Area',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-68.0, -30.0],
      },
      properties: {
        title: 'Ischigualasto / Talampaya Natural Parks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.9830555556, 68.255],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.4, 5.3],
      },
      properties: {
        title: 'Konso Cultural Landscape',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [22.7458333333, 68.6825],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [57.0, 19.7],
      },
      properties: {
        title: 'Arabian Oryx Sanctuary',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [48.53333333, 32.0833],
      },
      properties: {
        title: 'Tchogha Zanbil',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.6633333333, 70.67],
      },
      properties: {
        title: 'Struve Geodetic Arc',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [23.18333, 69.95],
      },
      properties: {
        title: 'Rock Art of Alta',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-49.5, 69.13333333],
      },
      properties: {
        title: 'Ilulissat Icefjord',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [94.1580555556, 69.0469444444],
      },
      properties: {
        title: 'Putorana Plateau',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [128.1, 35.8],
      },
      properties: {
        title: 'Haeinsa Temple Janggyeong Panjeon, the Depositories for the Tripitaka Koreana Woodblocks',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [37.955, 26.7836111111],
      },
      properties: {
        title: 'Al-Hijr Archaeological Site (Madâin Sâlih)',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-89.36916667, 13.8275],
      },
      properties: {
        title: 'Joya de Cerén Archaeological Site',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-71.75, -12.25],
      },
      properties: {
        title: 'Manú National Park',
      },
    },
  ],
};
